import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { TextField, Autocomplete, Button, MenuItem, InputAdornment, Box, Card, CardContent, IconButton, FormControlLabel, Checkbox, Divider, Fab, CircularProgress, Grid, Radio, RadioGroup, List, ListItemButton, ListItemText, Popper, Paper, ClickAwayListener } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from '@mui/icons-material/Remove';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { FormControl } from "@mui/base";
import AttachmentsUploader, { AttachmentsUploaderRef, MultipleAttachment } from "../../../components/AttachmentsUploader";
import { ApiResponse } from "../../../models/ApiResponse";
import { KeyValues } from "../../../models/Items/FilterOptions";
import api from "../../../services/ApiService";
import moment from "moment";
import { useFormik } from "formik";
import { DATE_FORMAT } from "../../../utils/constants";
import { Item } from "../../../models/Items/Item";
import {  ASSIGNMENTS_FETCH_WARNING, BILL_OF_MATERIALS_LAYOUT_CATEGORY, COPY_EXCLUDED_FIELDS, DEVELOPMENT_TYPE_DROPDOWN_OPTIONS, FIELDS_WITH_DISPLAY_TEXT, FIELD_NAMES, ITEM_STATUS_ENUM, MANAGE_CHECKLIST_GRID, MANAGE_QUOTES_GRID, MULTI_SELECT_FIELD_NAMES, NO_ASSIGNMENTS_WARNING, QUOTE_APPROVAL_TYPE_DROPDOWN_OPTIONS, REFERENCE_FIELDS_FOR_EDIT_PRODUCT, TOOLING_ATTACHMENT_LABEL, USER_ASSIGNMENTS_VALIDATION_MESSAGES, attachmentLevels, attachmentsValidationMessages, createProductValidations, dataFieldNames, initialValues } from "./Constants";
import { EditItemDropdownOptions } from "../../../models/Items/EditItemDropdownOptions";
import { toast } from "react-toastify";
import Select from '@mui/material/Select';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AttachmentDetail } from "../../../models/AttachmentDetail";
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ConfirmationModal from "../../../components/ConfirmationModal";
import CloseIcon from "@mui/icons-material/Close";
import Tags from "../../../components/Tags";
import { Tag } from "../../../models/Tag";
import EditProductGridView from "./EditProductGridView";
import UserAssignments, { UserAssignmentFieldValue, UserDropdownOptions } from "../../../components/UserAssignments";
import { UserAssignment } from "../../../models/UserAssignment";
import SessionService from "../../../services/SessionService";
import { Permissions } from "../../../models/Enum";
import { BomGridView } from "../../../models/Items/BomGridView";
import { MRT_ColumnDef, MRT_Row, MRT_TableContainer, useMaterialReactTable } from "material-react-table";
import { Delete } from "@mui/icons-material";
import { ProductLayoutCategoryDetail } from "../../../models/Items/ProductLayoutCategoryDetail";
import AutoCompleteStockCode from "../../../components/AutoCompleteStockCode";
import ToggleSwitchButton from "../../../components/ToggleSwitchButton";
import ProductComments, { NewComment } from "../../../components/ProductComments";
import { ProductComment } from "../../../models/ProductComment";
import { ProductLayoutFieldDetail } from "../../../models/Items/ProductLayoutFieldDetail";
import { BomType } from "../../../models/BomType";
import StageCheckList from "../../../components/StageCheckList";
import { ProductStageCheckListDetail } from "../../../models/ProductStageCheckListDetail";
import { PrjStageWithStatusAndTag } from "../../../models/PrjStage";
import BOMComponentModal from "../../../components/CreateBOMComponent";
import { User } from "../../../models/User";
import AcceptedQuote from "../../../components/AcceptedQuote";
import QuoteDetailsComparisonModal from "../../../components/QuoteDetailsComparisonModal";
import { QuoteBasicDetail } from "../../../models/Quotes/QuoteBasicDetail";
import { ToolingDetail } from "../../../models/Tooling/ToolingDetail";
import ToolingInformation, { ToolingDetails } from "../../../components/ToolingInformation";
import { fetchUserAssignmentsFromBaseCode } from "../../../components/fetchProductAssignments";
import { formatAmount, getInputTitle, sortByKey, sortCVLFieldOptions } from "../../../utils/helpers";
import AddOrSelectAutocomplete from "../../../components/AddOrSelectAutocomplete";
import AddSeriesNameModal, { useProductSeriesName } from "../../../components/AddSeriesNameModal";
import Loader from "../../../components/Loader";

const EditProduct = () => {

  const { editItemId } = useParams();
  const navigate = useNavigate();
  const location = useLocation() as any;

  const copyState = (location && location.state) || {};
  const isCopyMode = copyState?.viewMode === "CopyProductDetail" && !!copyState?.copyProductId;
  const sourceProductId = isCopyMode ? copyState.copyProductId : editItemId;
  const { copyBaseCode = '', copyPdStockcode = '', copyStockcode = '' } = copyState || {};

  const queryParameters = new URLSearchParams(window.location.search);
  const pageQueryParams = queryParameters.get("page");

  const [productLayoutFields, setProductLayoutFields] = useState<ProductLayoutCategoryDetail[]>([]);
  const [accordianExpanded, setAccordianExpanded] = useState<string[]>([]);
  const [dropDownOptions, setDropDownOptions] = useState<EditItemDropdownOptions>({});
  const [dropdownOptionsLoading, setDropdownOptionsLoading] = useState(true);
  const [selectedDropDownOptions, setSelectedDropDownOptions] = useState<any>(
    {}
  );
  const [editItem, setEditItem] = useState<Item>(null);
  const [fieldsDisabled, setFieldsDisabled] = useState<string[]>([]);
  const [attachments, setAttachments] = useState<MultipleAttachment[]>([]);
  const [deleteAttachmentIds, setDeleteAttachmentIds] = useState<number[]>([]);
  const [selectedTagOptions, setSelectedTagOptions] = useState<Tag[]>([]);
  const [commentList, setCommentList] = useState<ProductComment[]>([]);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showBaseCodeModificationConfirmModal, setShowBaseCodeModificationConfirmModal] = useState(false);
  const [checkListStatus, setCheckListStatus] = useState<ProductStageCheckListDetail[]>([]);
  const [isCheckListChanged, setIsCheckListChanged] = useState<boolean>(false);
  const [bomList, setBomList] = useState<BomGridView[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [multiSelectSearchTerms, setMultiSelectSearchTerms] = useState<Record<string, string>>({});
  const [multiSelectDialogOpen, setMultiSelectDialogOpen] = useState<Record<string, boolean>>({});
  const [multiSelectAnchorEls, setMultiSelectAnchorEls] = useState<Record<string, HTMLElement | null>>({});
  const [selectedBOMItem, setSelectedBOMItem] = useState(null);
  const [qty, setQty] = useState('');
  const [bomQtyError, setBomQtyError] = useState(false);
  const [bomErrorMessage, setBomErrorMessage] = useState('');
  const [assignmentEditableFields, setAssignmentEditableFields] = useState([]);
  const [sectionOpenHistory, setSectionOpenHistory] = useState<string[]>([]);
  const [formValueBaseCode, setFormValueBaseCode] = useState<string>();
  const [isFetchAssignmentsFailed, setIsFetchAssignmentsFailed] = useState<boolean>(false);
  const [userAssignmentsApiRunning, setUserAssignmentsApiRunning] = useState<boolean>(null);
  const [isRefreshCalled, setIsRefreshCalled] = useState(false);
  const [accordianCategories, setAccordianCategories] = useState<string[]>([]);
  const [expandAll, setExpandAll] = useState<boolean>(false);
  const [showBaseCodeLevelCheckListModificationConfirmModal, setShowBaseCodeLevelCheckListModificationConfirmModal] = useState(false);
  const [isBasecodeChecklistApplyForAll, setIsBasecodeChecklistApplyForAll] = useState(false);
  const [isBasecodeModifyForAll, setIsBasecodeModifyForAll] = useState(false);
  const [isConfirmationSet, setIsConfirmationSet] = useState(false);
  const [isProductAttachmentsFetched, setIsProductAttachmentsFetched] = useState(false);
  const initialUserAssignment: UserAssignment = {
    userId: "",
    assignmentId: "",
    id: 0
  };

  const [selectedUserAssignments, setSelectedUserAssignments] = useState<UserAssignmentFieldValue[]>([initialUserAssignment]);
  const sessionService = SessionService.getInstance();

  /*
    This dropdown option state are used separately because this options are dependent on the edit product data
    and dropdown options data, it was being overriden when used with same dropdown options state.
   */
  const [statusDropDownOptions, setStatusDropDownOptions] = useState<KeyValues[]>([]);
  const [functionDropDownOptions, setFunctionDropDownOptions]= useState<KeyValues[]>([]);
  const [tagMenuOptions, setTagMenuOptions] = useState<Tag[]>([]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [showFab, setShowFab] = useState(true);
  const [showAddBOMComponentModal, setShowAddBOMComponentModal] = useState(false);
  const [assignmentRoleDropdownOptions, setAssignmentRoleDropdownOptions] = useState<KeyValues[]>([]);
  const [userDropdownOptions, setUserDropdownOptions] = useState<UserDropdownOptions[]>([]);
  const [selectedQuote, setSelectedQuote] = useState<string>("");
  const [selectedVendorForQuote, setSelectedVendorForQuote] = useState<number>(null);
  const [quoteCalculationFieldsUpdateModalOpen, setQuoteCalculationFieldsUpdateModalOpen] = useState<boolean>(false);
  const [oldQuoteDetailsForIPCubeUpdates, setOldQuoteDetailsForIPCubeUpdates] = useState<QuoteBasicDetail & { itemVendorCost: number}>(null);
  const [newQuoteDetailsForIPCubeUpdates, setNewQuoteDetailsForIPCubeUpdates] = useState<QuoteBasicDetail & { itemVendorCost: number}>(null);
  const [toolingDetails, setToolingDetails] = useState<ToolingDetails>();
  const [isLoadingExpand, setIsLoadingExpand] = useState(false);
  const [changedFieldsForCalculation, setChangedFieldsForCalculation] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [prjStageTags, setPrjStageTags] = useState<PrjStageWithStatusAndTag[]>([]);
  const [quotesForEditProductPage, setQuotesForEditProductPage] = useState<(QuoteBasicDetail & { itemVendorCost: number })[]>([]);
  const uploaderRef = useRef<AttachmentsUploaderRef>(null);
  const defaultNoteHeight = 23;
  const [isNotesHeightChanged, setIsNotesHeightChanged] = useState<boolean>(false);
  const [fieldLabelsPair, setFieldLabelsPair] = useState<any>({});

  const compareQuoteCalculationFields = [
    "ipCube",
    "brandCollection",
    "brandCollectionDisplayText",
    "marketingDesigner",
    "marketingDesignerDisplayText",
    "royaltyDesigner",
    "royaltyDesignerDisplayText",
    "category",
    "categoryDisplayText",
    "htsMaterial",
    "htsMaterialDtl",
    "countryOfOrigin",
    "countryOfOriginDisplayText",
    "itemVendorCost",
    "dnPrice",
    "quoteId"
  ];

  const disableOnQuotesFields = [
    "itemVendorCost",
    "dnPrice",
  ];

  const stickyFields = [
    { fieldName: "id", label: "Product ID" },
    { fieldName: "stockcode", label: "Stock Code" },
    { fieldName: "pdStockcode", label: "PD StockCode" },
    { fieldName: "baseCode", label: "Base Code" },
    { fieldName: "pdCode", label: "PD BaseCode" },
    { fieldName: "shortDesc", label: "Short Description", required: true },
    { fieldName: "longDesc", label: "Description" },
    { fieldName: "marketingDesigner", label: "Marketing Designer" },
    { fieldName: "pdFamilyName", label: "PD Family" },
    { fieldName: "seriesName", label: "Series Name" },
    { fieldName: "vendor", label: "Vendor" },
    { fieldName: "stage", label: "Stage", required: true },
    { fieldName: "status", label: "Status", required: true },
    { fieldName: "category", label: "Category", required: true },
    { fieldName: "function", label: "Function", required: true },
  ];
  
  const formik = useFormik({
    initialValues,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: createProductValidations,
    onSubmit: async () => {
      showCalculationChangedModalOrSubmit()
    }
  });

  const {
    seriesNameOptions,
    addSeriesNameModalProps,
    openAddSeriesName,
    rememberSeriesNameInput,
    holdProductSubmitForNewSeriesName,
    getSeriesNameFormValues,
    lockedSeriesRef,
  } = useProductSeriesName({
    formik,
    selectedSeriesName: selectedDropDownOptions?.seriesName,
    setSelectedDropDownOptions,
    dropDownSeriesNames: dropDownOptions.seriesNames,
  });

  const onSubmitHandler = async () => {
    try {
        setQuoteCalculationFieldsUpdateModalOpen(false);
        let isValid = true;
        // error messages to display in toast
        const newErrors: any = {};
        
        // Add attachment and Delete attachment logic to submit data in api request
        if (attachments && attachments.length > 0) {
          const containsLevelBC = attachments.some((a) => a.lvl === attachmentLevels.BC);
          const containsLevelSC = attachments.some((a) => a.lvl === attachmentLevels.SC);
          const {
            stockCodeToastError,
            baseCodeToastError,
            stockCodeInputBoxError,
            baseCodeInputBoxError,
            attachmentTypeToastError
          } = attachmentsValidationMessages;

          const attachmentTypes = attachments?.filter(item => !item?.attachId)?.map((a) => a.attachmentTypeDisplayText)
            .filter((type) => type && type !== TOOLING_ATTACHMENT_LABEL);
          if (attachmentTypes?.length > 0 && new Set(attachmentTypes).size !== attachmentTypes.length) {
            const duplicates = attachmentTypes.filter((item, index) =>
              attachmentTypes.indexOf(item) !== index
            );

            const duplicateNames = Array.from(new Set(duplicates));
            newErrors.attachType = `Only 1 file for each attachment type is allowed in an upload. The following attachment ${duplicateNames.length === 1 ? "type has" : "types have"} more than 1 file of the same type "${duplicateNames.join(", ")}"`;
            isValid = false;
          }

          if ((containsLevelBC && !(formik.values[FIELD_NAMES.baseCode])) ||
            (containsLevelBC && formik.values[FIELD_NAMES.baseCode].trim() === "")) {
            formik.setErrors({ baseCode: baseCodeInputBoxError });
            newErrors.baseCode = baseCodeToastError;
            isValid = false;
          }

          if ((containsLevelSC && !(formik.values[FIELD_NAMES.stockcode])) ||
            (containsLevelSC && formik.values[FIELD_NAMES.stockcode].trim() === "")) {
            formik.setErrors({ stockcode: stockCodeInputBoxError });
            newErrors.stockCode = stockCodeToastError;
            isValid = false;
          }

          const checkAttachmentType = attachments.some((a) => a.attachType == 0 && a.disabled === false);

          if (checkAttachmentType) {
            newErrors.attachType = attachmentTypeToastError;
            isValid = false;
          }

        if (isValid && uploaderRef.current && !isCopyMode) {
              await uploaderRef.current.uploadAttachmentsToAPI(editItemId, formik, containsLevelBC, containsLevelSC);
          }
        }

        // Add user assignment validation check
        if(selectedUserAssignments.length > 0) {
          const checkFirstRowUserAssignment = selectedUserAssignments.some((ua) => ua.userId && ua.assignmentId === "");
          
          const checkUserFromSecondRow = selectedUserAssignments.slice(1).some((ua) => ua.userId === "");
          const checkAssignmentFromSecondRow = selectedUserAssignments.slice(1).some((ua) => ua.assignmentId === "");
  
          const { userError, assignmentRoleError } = USER_ASSIGNMENTS_VALIDATION_MESSAGES;
          if(checkFirstRowUserAssignment) {
            newErrors.assignmentId = assignmentRoleError;
            isValid = false;
          }
  
          if(checkUserFromSecondRow) {
            newErrors.userId = userError;
            isValid = false;
          }
  
          if(checkAssignmentFromSecondRow) {
            newErrors.assignmentId = assignmentRoleError;
            isValid = false;
          }
        }
        
        // Check if there are any errors
        if (isValid === false) {
          // Combine all error messages
          const errorMessage = Object.values(newErrors).join(', ');
          // Display the combined error message in a toast notification
          toast.error(errorMessage);
        }
        
        if (isValid === true) {
          setDisableSubmit(true);
          // Submit Attachment Id in Delete attachment api
          if (deleteAttachmentIds && deleteAttachmentIds.length > 0) {
            for (const id of deleteAttachmentIds) {
              await api.delete<ApiResponse<any>>(
                `/Attachment/remove?AttachmentId=${id}`
              );
            }
            setDisableSubmit(false);
            setDeleteAttachmentIds([]);
          }

          if (isCopyMode) {
            const basecodeLevelChecklists = checkListStatus?.find(chl => chl.isBaseCodeLevel === true && !!chl.checkListItemName);
            if (basecodeLevelChecklists) {
              setShowBaseCodeLevelCheckListModificationConfirmModal(true);
            }
            else {  
              await submitCopyProduct();
            }
          } else {
            if (editItem.baseCode && formik.values[FIELD_NAMES.baseCode] && (editItem.baseCode !== (formik.values[FIELD_NAMES.baseCode]).trim())) {
              setShowBaseCodeModificationConfirmModal(true);
            } else {
              const basecodeLevelChecklists = checkListStatus?.find(chl => chl.isBaseCodeLevel === true);

              if (basecodeLevelChecklists) {
                setShowBaseCodeLevelCheckListModificationConfirmModal(true);
              }
              else {  
                submitFormDataToItemApi();
              }
            }
          }
        }
      } catch (error: any) {
        setDisableSubmit(false);
        console.error("Exception from edit product", error);
      }
  }

  const showCalculationChangedModalOrSubmit = async () => {
    if (holdProductSubmitForNewSeriesName()) {
      return;
    }
    const changedFields = compareQuoteCalculationFields.filter(field => editItem[field] != formik.values[field]);

      if(changedFields?.length > 0 && formik.values?.quoteId){
        setIsSubmitting(true);
        await fetchCalculationAPI();
        return;
      } else {
        onSubmitHandler();
      }
  }

  const getFormattedDate = (fieldName: string) => {
    return formik.values[fieldName]
      ? moment(formik.values[fieldName]).format(DATE_FORMAT)
      : null;
  };

  const getSlIntroDatePayload = () => {
    if (formik.values[FIELD_NAMES.isSLIntroDateTBD]) {
      return null;
    }
    return getFormattedDate(FIELD_NAMES.slIntroDate);
  };

  const checkAssignmentWithUserId = (): boolean => {
    const getLoggedInUserDetail = sessionService.getCurrentUser();

    // Check if userAssignments exists and has at least one element
    if (editItem?.userAssignments?.length) {
      return editItem.userAssignments.some(
        (ua: UserAssignment) => ua?.userId === getLoggedInUserDetail?.id
      );
    }

    return false; // Return false if userAssignments is empty or undefined
  };

  useEffect(() => {
    // Retrieve the list of visited products from localStorage
    const visitedProducts: Item[] = JSON.parse(localStorage.getItem('visitedProducts')) || [];

    // Function to update the product list when revisited
    const updateVisitedProducts = (product) => {
      // Remove the product if it's already in the list
      const index = visitedProducts.findIndex(p => p.id === product.id);
      if (index !== -1) {
        visitedProducts.splice(index, 1); // Remove the product from its current position
      }
      // Add the product to the beginning of the list
      visitedProducts.unshift(product);

      // Keep the list to a maximum of 8 products
      if (visitedProducts.length > 8) {
        visitedProducts.pop(); // Remove the last product if the length exceeds 10
      }

      // Store the updated list back to localStorage
      localStorage.setItem('visitedProducts', JSON.stringify(visitedProducts));
    };

    if(editItem && editItem?.id) {
      // Example: Update with a product (this could be dynamic based on the page or user action)
      const productInfo = {
        id: editItem.id,
        shortDesc: editItem.shortDesc,
        stockcode: editItem.stockcode,
        baseCode: editItem.baseCode,
        stageDisplayText: editItem.stageDisplayText,
        statusDisplayText: editItem.statusDisplayText
      };

      if(checkAssignmentWithUserId()) updateVisitedProducts(productInfo);
    }
  }, [editItem]);

  /**
   * This function is used to submit product data to api
   * @param baseCodeModificationConfirm - Base code modification confirmation value "Yes" or "No"
   */
  const submitFormDataToItemApi = async () => {
    try {
      setQuoteCalculationFieldsUpdateModalOpen(false);
      const data = {
        ...formik.values,
        ...getSeriesNameFormValues(),
        sellingLineInStockDate: getFormattedDate(FIELD_NAMES.sellingLineInStockDate),
        slIntroDate: getSlIntroDatePayload(),
        reqDate: getFormattedDate(FIELD_NAMES.reqDate),
        agreedSampleReadyDate: getFormattedDate(FIELD_NAMES.agreedSampleReadyDate),
        changeBaseCodeForAllProducts: isBasecodeModifyForAll,
        applyBaseCodeChecklistForAll: isBasecodeChecklistApplyForAll,
        productStageCheckLists: checkListStatus
      };

      if(selectedQuote !== "") {
        data.quoteId = Number(selectedQuote);
        if(selectedVendorForQuote != data?.vendor) {
          toast.warn('The quote you are attempting to accept, quote vendor is not matched with the product vendor');
        }
      }

      // Add tags data to submit in api request
      data.tags = (selectedTagOptions || []).map(t => t.id);

      data.userAssignments = null;

      // Trim stockcode if it contains value
      if (data.stockcode) {
        data.stockcode = data.stockcode.trim();
      }
      // Trim basecode if it contains value
      if (data.baseCode) {
        data.baseCode = data.baseCode.trim();
      }

      data.bomDetails = bomList.map(bomItem => {
        return {
          id: bomItem.id, // this is BomDetails table's ID Field
          sequenceNum: bomItem.sequenceNum,
          componentItemId: bomItem.componentItemId, // this is item table's ID Field
          quantity: bomItem.quantity
        } 
      }) || [];

      setDisableSubmit(true);
      // Submit product data in Update product api
      const updateItemResponse = await api.put<ApiResponse<any>>(
        "/Item",
        {
        ...data, 
        itemVendorCost: formik?.values?.quoteId ? newQuoteDetailsForIPCubeUpdates?.itemVendorCost || null : formik?.values?.itemVendorCost || null,
        dnPrice: formik?.values?.quoteId ? newQuoteDetailsForIPCubeUpdates?.dnPrice || null : formik?.values?.dnPrice || null
      }
      );
      if (updateItemResponse?.isSuccess) {
        setDisableSubmit(false);
        if (updateItemResponse?.data.length > 0) {
          updateItemResponse?.data.map((item) => {
            if (item.isSuccess) {
              toast.success(item.message);
            }
            else {
              toast.error(item.message);
            }
          })
        }
        refetchProductDetail();
        setIsCheckListChanged(true);
        setCheckListStatus([]);
        setIsRefreshCalled(true);
        setIsBasecodeChecklistApplyForAll(false);
        setIsBasecodeModifyForAll(false);
        setIsConfirmationSet(false);
      }
    } catch (error: any) {
      setDisableSubmit(false);
      setIsBasecodeChecklistApplyForAll(false);
      setIsBasecodeModifyForAll(false);
      setIsConfirmationSet(false);
      console.error("Exception from edit product", error);
    } finally {
      setIsSubmitting(false);
      setDisableSubmit(false);
    }
  };

  const submitCopyProduct = async () => {
    try {
      const containsLevelBC = attachments.some((a) => a.lvl === attachmentLevels.BC);
      const containsLevelSC = attachments.some((a) => a.lvl === attachmentLevels.SC);

      const data: any = {
        ...formik.values,
        id: undefined,
        sellingLineInStockDate: getFormattedDate(FIELD_NAMES.sellingLineInStockDate),
        slIntroDate: getSlIntroDatePayload(),
        reqDate: getFormattedDate(FIELD_NAMES.reqDate),
        agreedSampleReadyDate: getFormattedDate(FIELD_NAMES.agreedSampleReadyDate),
        productStageCheckLists: checkListStatus,
        applyBaseCodeChecklistForAll: isBasecodeChecklistApplyForAll,
      };

      if (data.stockcode) {
        data.stockcode = data.stockcode.trim();
      }
      if (data.baseCode) {
        data.baseCode = data.baseCode.trim();
      }

      data.tags = [];

      if (selectedUserAssignments?.[0]?.userId && selectedUserAssignments?.[0]?.assignmentId) {
        data.userAssignments = selectedUserAssignments;
      } else {
        data.userAssignments = null;
      }

      const createItemResponse = await api.post<ApiResponse<any>>(
        "/Item",
        data
      );

      if (createItemResponse?.isSuccess) {
        const newItemId = createItemResponse?.data;
        toast.success(createItemResponse?.message);

        if (uploaderRef.current && (containsLevelBC || containsLevelSC)) {
          await uploaderRef.current.uploadAttachmentsToAPI(newItemId, formik, containsLevelBC, containsLevelSC);
        }

        navigate("/products");
      }
    } catch (error: any) {
      console.error("Exception from copy product", error);
    } finally {
      setDisableSubmit(false);
    }
  };

  const fetchCalculationAPI = async () => {
    try {

      const selectedQuoteDetail = quotesForEditProductPage.find(quote => quote.id == formik.values?.quoteId);
      const {
        productId,
        fobCost,
        tariffPercent,
        umapPrice,
      } = selectedQuoteDetail;

      const {
        ipCube,
        brandCollection,
        brandCollectionDisplayText,
        marketingDesigner,
        marketingDesignerDisplayText,
        royaltyDesigner,
        royaltyDesignerDisplayText,
        category,
        categoryDisplayText,
        htsMaterial,
        htsMaterialDtl,
        countryOfOrigin,
        countryOfOriginDisplayText,
        dnPrice,
        itemVendorCost
      } = formik.values;
      const oldValues = {...selectedQuoteDetail, itemVendorCost, dnPrice}
      setOldQuoteDetailsForIPCubeUpdates(oldValues);

      // setDisableSubmit(true);
      const quoteCalculationResponse = await api.post<ApiResponse<QuoteBasicDetail>>(
        "/Quote/calculation",
        {
          productId,
          fobCost,
          tariffPercent,
          ipCube: Number(ipCube || 0),
          umapPrice: umapPrice || null,
          brandCollection,
          brandCollectionDisplayText,
          marketingDesigner,
          marketingDesignerDisplayText,
          royaltyDesigner,
          royaltyDesignerDisplayText,
          category,
          categoryDisplayText,
          htsMaterial,
          htsMaterialDtl,
          countryOfOrigin,
          countryOfOriginDisplayText,
        }
      );

      if (quoteCalculationResponse?.isSuccess) {
        const { data } = quoteCalculationResponse;

        const newQuoteDetails = {
          ...data,
          ipCube: Number(formik.values?.ipCube || 0)
        };
        const newQuoteWithAdditionalDetails = {...newQuoteDetails, 
          ipCube,
          brandCollection,
          brandCollectionDisplayText,
          marketingDesigner,
          marketingDesignerDisplayText,
          royaltyDesigner,
          royaltyDesignerDisplayText,
          category,
          categoryDisplayText,
          htsMaterial,
          htsMaterialDtl,
          countryOfOrigin,
          countryOfOriginDisplayText,
          itemVendorCost: selectedQuoteDetail?.fobCost,
        };
        setNewQuoteDetailsForIPCubeUpdates(newQuoteWithAdditionalDetails);
  
        const compareKeys = Object.keys(newQuoteWithAdditionalDetails);
        const changedCalculatedFields = compareKeys.filter(field => oldValues[field] != newQuoteWithAdditionalDetails[field])
        
        if(changedCalculatedFields.length > 0) {
          setChangedFieldsForCalculation(changedCalculatedFields);
          setQuoteCalculationFieldsUpdateModalOpen(true);
        } else {
          onSubmitHandler();
        }
      }
    } catch (error) {
      console.error("Quote Calculation API call failed", error);
    }
  };

  useEffect(() => {
    const selectedQuote = quotesForEditProductPage.find(q => q.id == formik.values?.quoteId) || null;
    setOldQuoteDetailsForIPCubeUpdates(selectedQuote as QuoteBasicDetail & { itemVendorCost: number });
  }, [formik.values?.quoteId])

  const fetchSelectedQuoteDetails = async (quoteId: number) => {
    try{
      const resp = await api.get<ApiResponse<QuoteBasicDetail & {stockcode : string; itemVendorCost: number; }>>(`/Quote/${quoteId}`);

      if (resp?.isSuccess) {
        setQuotesForEditProductPage(resp.data ? [resp.data] : []);
      }
    } catch (error) {
      console.error("Error fetching selected quote details", error);
    }
  }

  const handleQuoteSelection = async (event: any, id: string) => {
    const checkedValue = event.target.checked
    if(checkedValue){
      // Get the selected quote ID from the dropdown event
      const selectedQuoteId = id;
      // Find the selected quote details from the available quote options
      const selectedQuoteDetail = quotesForEditProductPage.find(q => q.id?.toString() == selectedQuoteId?.toString()) || null;
      
      // Store the selected quote details for IPCube updates
      setOldQuoteDetailsForIPCubeUpdates(selectedQuoteDetail);
      
      // Extract the VendorId value from the selected quote details
      const selectedVendorId = selectedQuoteDetail?.vendorId;
      formik.setValues({...formik.values, quoteId: Number(selectedQuoteId)});

      // Update the state with the selected quote ID
      setSelectedQuote(selectedQuoteId);
      // Update the state with the vendor ID associated with the selected quote
      setSelectedVendorForQuote(selectedVendorId);
    } else {
      setSelectedQuote(null);
      formik.setValues({...formik.values, quoteId: null});
    }
  };

  useEffect(() => {
    fetchProductLayoutFields();
    getAllDropDownOptions();
    fetchStageTag();
  }, []);

  useEffect(() => {
    if (sourceProductId) {
      fetchEditItemData(sourceProductId);
      fetchProductCommentList();
      getAssignmentRoleList();
      getUserList();
    }

    return () => {       
      resetStateValue(); 
    };
  }, [sourceProductId]);

  useEffect(() => {
    const bindDropdowns = async () => {
      if(Object.keys(dropDownOptions).length > 0) {        
        if(editItem) {
          prepareStatusDropDownOptions(editItem.stage);
          prepareFunctionDropDownOptions(editItem.category);
          prepareTagOptions(editItem.stage, editItem.tags);
          fetchAssignmentEditableFields(editItem.userAssignments);
        }
      }
    }
    
    bindDropdowns();    
  }, [dropDownOptions, editItem]);

  const refetchProductDetail = () => {
    if (sourceProductId) {
      fetchEditItemData(sourceProductId);
    }
  };

  const tagIdMap = prjStageTags.map(i => i.tags.map(i => i.id))
  const uniqueTagsIdList = tagIdMap.flat().filter((value, index, self) => self.indexOf(value) === index);
  
  const fetchStageTag = async () => {
      const stageTagResponse = await api.get<ApiResponse<PrjStageWithStatusAndTag[]>>("/Picklist/stages");
      setPrjStageTags(stageTagResponse.data || []);
  }

  const fetchMemoizedFunction = useCallback(() => {
    if(editItem) {
      fetchAllAttachments(editItem);
    }
  }, [editItem]);
  
  useEffect(() => {
    fetchMemoizedFunction(); // Calls fetchMemoizedFunction when `editItem` updates
  }, [fetchMemoizedFunction]);

  useEffect(() => {
    if(isProductAttachmentsFetched){
      if(!selectedDropDownOptions?.seriesName?.id) {
        setAttachments(attachments?.filter(a => a.attachmentTypeDisplayText !== TOOLING_ATTACHMENT_LABEL));
        setToolingDetails(null);
      } else {
        fetchToolingDetails();
      }
    }
  }, [selectedDropDownOptions?.seriesName, isProductAttachmentsFetched])

  const fetchAllAttachments = async (productDetail: Item) => {
    try {
      // First, call getAllAttachmentsList API
      const getAttachmentsData = await api.post<ApiResponse<AttachmentDetail[]>>(
        `/Attachment/list?itemCode=${productDetail.id}`,
        null
      );

      let attachmentsList: MultipleAttachment[] = [];
      const oldSeriesAttachments = attachments?.filter(a => a.attachmentTypeDisplayText === TOOLING_ATTACHMENT_LABEL);

      if (getAttachmentsData?.data && getAttachmentsData?.data.length > 0) {
        getAttachmentsData.data
          .filter((attachmentItem) => !isCopyMode || attachmentItem.level === attachmentLevels.BC)
          .map((attachmentItem) => {
            attachmentsList.push({
              attachId: attachmentItem.attachID,
              fileName: attachmentItem.fileName,
              link: attachmentItem.link,
              attachType: attachmentItem.attachmentTypeId,
              attachmentTypeDisplayText: attachmentItem.attachmentTypeDisplayText,
              lvl: attachmentItem.level,
              attachmentDate: attachmentItem.attachmentDate,
              disabled: true,
            });
          });
      }
      // Once both data are fetched, update the state with the complete list
      setAttachments(oldSeriesAttachments?.length > 0 ? [...attachmentsList, ...oldSeriesAttachments] : attachmentsList);
      setIsProductAttachmentsFetched(true);
    } catch (error) {
      console.error("Error fetching attachments:", error);
    }
  };

  const fetchToolingDetails = async () => {
    try {
      // Clear the tooling attachments as series name is changed
      let attachmentsList: MultipleAttachment[] = attachments?.filter(a => a.attachmentTypeDisplayText !== TOOLING_ATTACHMENT_LABEL);
      // Now, call fetchToolingDetailsBySeriesName API
      if (selectedDropDownOptions?.seriesName?.id) {
        const toolingDetailsResponse = await api.get<ApiResponse<ToolingDetail>>(
          `/Tooling/${selectedDropDownOptions?.seriesName?.name}`
        );
        setToolingDetails({
          seriesName: selectedDropDownOptions?.seriesName?.name,
          runningTotal: toolingDetailsResponse?.data?.runningTotal,
          totalBudget: toolingDetailsResponse?.data?.totalBudget
        });

        if (toolingDetailsResponse?.data?.toolings?.length > 0) {
          toolingDetailsResponse.data.toolings.map((toolingAttachment) => {
            attachmentsList.push({
              fileName: toolingAttachment.fileName,
              link: toolingAttachment.link,
              attachType: 0,
              attachmentTypeDisplayText: TOOLING_ATTACHMENT_LABEL,
              attachmentDate: toolingAttachment.attachDate,
              disabled: true,
            });
            setAttachments(attachmentsList);
          });
        } else {
          setAttachments(attachmentsList);
        }
      } else if(!selectedDropDownOptions?.seriesName?.id) {
        setAttachments(attachmentsList);
        setToolingDetails(null);
      }
    } catch (e) {
      console.error("Error fetching tooling details:", e);
    }
  }

  /* 
    This function is used to get assignment role drop down options from api
   */
    const getAssignmentRoleList = () => {
      try {
        api
          .get<ApiResponse<any[]>>(`/Assignment/list`)
          .then((response: ApiResponse<any[]>) => {
            if (response.isSuccess) {
              if (response.data?.length > 0) {
                const assignments = response.data.filter(a => a.isActive === true)
                .map(u => {
                  return {
                    id: u.id,
                    name: u.name
                  }
                });
                setAssignmentRoleDropdownOptions(assignments);
              }
            } else {
              throw new Error(response?.message);
            }
          })
          .catch((error) => {
            console.error("Exception from Assignments", error);
          });
      } catch (error: any) {
        console.error(error.message);
      }
    };

  /* 
    This function is used to get user drop down options from api
  */
  const getUserList = () => {
    try {
      api
        .get<ApiResponse<User[]>>(`/UserRole`)
        .then((response: ApiResponse<User[]>) => {
          if (response.isSuccess) {
            if (response.data?.length > 0) {
              const users = response.data.filter((ul) => ul.isActive === true).map(ul => {
                return {
                  id: ul.id,
                  name: ul.name,
                  disabled: false
                }
              });
              setUserDropdownOptions(users);
            }
          } else {
            throw new Error(response?.message);
          }
        })
        .catch((error) => {
          console.error("Exception from User Role", error);
        });
    } catch (error: any) {
      console.error(error.message);
    }
  };

  /**
   * This function is used to fetch edit product layout fields from api and set it to state
   */
  const fetchProductLayoutFields = async () => {
    try {
      const response = await api
        .get<ApiResponse<ProductLayoutCategoryDetail[]>>(`/PickList/layoutFields`);
      if (response.isSuccess) {
        let { data } = response;

        const fieldLabelsPairs = {};
        data.map(cat => {
            if(cat.fields) {
                cat.fields.map(field => {
                  const matchedName = formRendererNames.find(
                    (fn) => fn.toLowerCase() === field.fieldName.toLowerCase()
                  );
                  fieldLabelsPairs[matchedName || field.fieldName] = field.label
                })
            };  
        })
        setFieldLabelsPair(fieldLabelsPairs);

        // BILL OF MATERIALS category needs to be pushed static in array as it is not present in api response
        data.unshift(MANAGE_CHECKLIST_GRID);
        if(!isCopyMode) data.push(BILL_OF_MATERIALS_LAYOUT_CATEGORY, MANAGE_QUOTES_GRID);
        setAccordianCategories(data.map((d) => d?.categoryName)?.filter(Boolean));
        // Update fields names recieved from api so that it matches with formRenderer keys to avoid casing errors
        data.map((lf) => {
          lf.fields.map((field) => {
            const matchedName = formRendererNames.find(
              (fn) => fn.toLowerCase() === field.fieldName.toLowerCase()
            );
            if (matchedName) {
              field.fieldName = matchedName;
            }
          });
        });
        setProductLayoutFields(data);
        setAccordianExpanded([data[1]?.categoryName]);
      } else {
        throw new Error(response.message);
      }
    } catch (error: any) {
      console.error(error?.message);
    }
  };

  /**
   * This function is used to get single product api data and set it to form
   * @param editItemParams - props object that includes product id and stockcode
   */
  const applyCopyAdapter = (item: Item): Item => {
    if (!isCopyMode || !item) {
      return item;
    }

    const adapted: any = { ...item };

    COPY_EXCLUDED_FIELDS.forEach((fieldKey) => {
      if (fieldKey in adapted) {
        adapted[fieldKey] = null;
      }
    });

    adapted.tags = [];

    return adapted;
  };

  const fetchEditItemData = async (editItemParams: any) => {
    try {
      return api
        .get<ApiResponse<Item>>(`/Item/${editItemParams}`)
        .then((response: ApiResponse<Item>) => {
          if (response.isSuccess) {
            const { data } = response;
            const adaptedData = applyCopyAdapter(data);
            formik.setValues({ ...adaptedData });
            setEditItem(adaptedData);
            setBomList(data.bomDetails);
            setSelectedQuote(String(data?.quoteId || ""));
            setIsProductAttachmentsFetched(false);
            if(data?.baseCode?.trim()) {
              setUserAssignmentsApiRunning(false);
            }
            if(data?.quoteId && !sectionOpenHistory.includes(MANAGE_QUOTES_GRID.categoryName)) {
              fetchSelectedQuoteDetails(data?.quoteId);
            }
            return data;
          } else {
            throw new Error(response.message);
          }
        })
        .catch((error) => {
          console.error("Exception from Get single product API", error);
          return null;
        });
    } catch (error: any) {
      console.error(error.message);
    }
  };



  /* 
    This function is used to get drop down options data from api
   */
  const getAllDropDownOptions = async () => {
    try {
      // using same filter options that we are using in Product Listing screen + some other drop down using separate API
      const dropDownSources = await api.get<
            ApiResponse<EditItemDropdownOptions>
          >(`/Item/active-dropdown-options`);
      // get data for the BOM type List
      const bomTypeDataResponse = await api.get<
            ApiResponse<BomType[]>
          >(`/PickList/bomtypes`);

      if (dropDownSources?.isSuccess && bomTypeDataResponse?.isSuccess) {
        
        const complianceOptions = [
          { id: 1, name: "Y", description: "Yes" },
          { id: 2, name: "N", description: "No" }
        ];
        dropDownSources.data.complianceOptions = complianceOptions;
        //Append dropdwon sources with the BOM Type response
        dropDownSources.data.bomTypes = bomTypeDataResponse.data;

        // Sort dropdown options
        sortCVLFieldOptions(dropDownSources.data);
        
        setDropDownOptions(dropDownSources.data);
        return dropDownSources.data;
      }
    } catch (error) {
      console.error("Exception from API", error);
    } finally {
      setDropdownOptionsLoading(false);
    }
  };

  /**
   * This function is used to fetch product comments from api and set it to state
   */
  const fetchProductCommentList = async () => {
    const sessionInfo: any = JSON.parse(
      window?.localStorage.getItem("session") || "{}"
    );
    try {
      const response = await api
        .get<ApiResponse<ProductComment[]>>(`/ProductComment/list/${editItemId || sourceProductId}`, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + sessionInfo.token,
          },
        }
        );
      if (response.isSuccess) {
        let { data } = response;
        if(data?.length > 0 && isCopyMode) {
          data = data.filter(comment => !!comment.baseCode);
        }
        setCommentList(data);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      console.error(error?.message);
    }
  };

  /**
   * This function is used to fetch assignment editable fields if session user doesn't have update product permission and user associated with assignment
   */
  const fetchAssignmentEditableFields = async (userAssignments: UserAssignment[]) => {
    const sessionUser = sessionService.getCurrentUser();
    const assignmentForSessionUser = userAssignments?.find((ua) => ua.userId === sessionUser.id);
    
    if (checkItemFormFieldPermission() && assignmentForSessionUser) {
      const { assignmentId } = assignmentForSessionUser;

      try {
        const response = await api
          .get<ApiResponse<string[]>>(`/Assignment/editable-fields/${assignmentId}`);
        
        if (response.isSuccess) {
          let { data } = response;
          // Update fields names recieved from api so that it matches with formRenderer keys to avoid casing errors
          const editableFieldNames: string[] = data?.reduce((acc, field) => {
            const matchedFieldName = formRendererNames.find(
              (fn) => fn.toLowerCase() === field.toLowerCase()
            );
            
            if (matchedFieldName) {
              acc.push(matchedFieldName);
            }
            return acc;
          }, []);

          setAssignmentEditableFields(editableFieldNames);
        } else {
          throw new Error(response?.message);
        }
      } catch (error: any) {
        console.error(error?.message);
      }
    }
  };

  const setValuesOfMultiSelectFields = (fieldName: string) => {
    // For "dataFieldsTypes"-backed dropdowns, the lookup key is in `dataFieldNames`.
    const attributeName = (dataFieldNames as any)?.[fieldName] ?? fieldName;
    const dropdownObject = getAttributeValues(attributeName);
    const selectedIds: any[] = Array.isArray((editItem as any)?.[fieldName]) ? (editItem as any)[fieldName] : [];

    return (
      dropdownObject
        ?.filter((item) => selectedIds.includes(item?.id))
        ?.map((item) => ({
          id: item?.id,
          description: item?.description,
          optionLabel: item?.optionLabel,
        })) || []
    );
  };

  /* 
    This function is used to set dropdown values of the product currently being edited
   */
  const setDropdownValuesFromEditItem = () => {
    setSelectedDropDownOptions({
      ...selectedDropDownOptions,
      // START : new CVL Fields
      certiNote: editItem.certiNote ?
      {
        id: editItem.certiNote,
        name: editItem.certiNoteDisplayText
      } : undefined,
      baseShape: editItem.baseShape ?
      {
        id: editItem.baseShape,
        name: editItem.baseShapeDisplayText
      } : undefined,
      batteryType: editItem.batteryType ?
      {
        id: editItem.batteryType,
        name: editItem.batteryTypeDisplayText
      } : undefined,
      bulbShape: editItem.bulbShape ?
      {
        id: editItem.bulbShape,
        name: editItem.bulbShapeDisplayText
      } : undefined,
      bulbShapeCode: editItem.bulbShapeCode ?
      {
        id: editItem.bulbShapeCode,
        name: editItem.bulbShapeCodeDisplayText
      } : undefined,
      canopyShape: editItem.canopyShape ?
      {
        id: editItem.canopyShape,
        name: editItem.canopyShapeDisplayText
      } : undefined,
      colorTemperature: editItem.colorTemperature ?
      {
        id: editItem.colorTemperature,
        name: editItem.colorTemperatureDisplayText
      } : undefined,
      cri: editItem.cri ?
      {
        id: editItem.cri,
        name: editItem.criDisplayText
      } : undefined,
      department: editItem.department ?
      {
        id: editItem.department,
        name: editItem.departmentDisplayText
      } : undefined,
      ledDimmingType: editItem.ledDimmingType ?
      {
        id: editItem.ledDimmingType,
        name: editItem.ledDimmingTypeDisplayText
      } : undefined,
      driverLocation: editItem.driverLocation ?
      {
        id: editItem.driverLocation,
        name: editItem.driverLocationDisplayText
      } : undefined,
      ledDriverType: editItem.ledDriverType ?
      {
        id: editItem.ledDriverType,
        name: editItem.ledDriverTypeDisplayText
      } : undefined,
      ledType: editItem.ledType ?
      {
        id: editItem.ledType,
        name: editItem.ledTypeDisplayText
      } : undefined,
      lightSource: editItem.lightSource ?
      {
        id: editItem.lightSource,
        name: editItem.lightSourceDisplayText
      } : undefined,
      locationRating: editItem.locationRating ?
      {
        id: editItem.locationRating,
        name: editItem.locationRatingDisplayText
      } : undefined,
      mountingType: editItem.mountingType ?
      {
        id: editItem.mountingType,
        name: editItem.mountingTypeDisplayText
      } : undefined,
      reportingBrand: editItem.reportingBrand ?
      {
        id: editItem.reportingBrand,
        name: editItem.reportingBrandDisplayText
      } : undefined,
      socketType: editItem.socketType ?
      {
        id: editItem.socketType,
        name: editItem.socketTypeDisplayText
      } : undefined,
      socket1Type: editItem.socket1Type ?
      {
        id: editItem.socket1Type,
        name: editItem.socket1TypeDisplayText
      } : undefined,
      socket2Type: editItem.socket2Type ?
      {
        id: editItem.socket2Type,
        name: editItem.socket2TypeDisplayText
      } : undefined,
      socket3Type: editItem.socket3Type ?
      {
        id: editItem.socket3Type,
        name: editItem.socket3TypeDisplayText
      } : undefined,
      wireColor: editItem.wireColor ?
      {
        id: editItem.wireColor,
        name: editItem.wireColorDisplayText
      } : undefined,
      skuRank: editItem.skuRank ?
      {
        id: editItem.skuRank,
        name: editItem.skuRankDisplayText
      } : undefined,
      bcRank: editItem.bcRank ?
      {
        id: editItem.bcRank,
        name: editItem.bcRankDisplayText
      } : undefined,
      vendorMOQType: editItem.vendorMOQType ?
      {
        id: editItem.vendorMOQType,
        name: editItem.vendorMOQTypeDisplayText
      } : undefined,
      itemStockingType: editItem.itemStockingType ?
      {
        id: editItem.itemStockingType,
        name: editItem.itemStockingTypeDisplayText
      } : undefined,
      warehouse: editItem.warehouse ?
      {
        id: editItem.warehouse,
        name: editItem.warehouseDisplayText
      } : undefined,
      slStatus: editItem.slStatus ?
      {
        id: editItem.slStatus,
        name: editItem.slStatusDisplayText
      } : undefined,
      romanticSize: editItem.romanticSize ?
      {
        id: editItem.romanticSize,
        name: editItem.romanticSizeDisplayText
      } : undefined,
      developmentType: editItem.developmentType ?
      {
        id: editItem.developmentType,
        name: editItem.developmentTypeDisplayText
      } : undefined,
      // END : new CVL Fields
      brandCollection: editItem.brandCollection ? 
      {
        id: editItem.brandCollection,
        name: editItem.brandCollectionDisplayText
      } : undefined,
      marketingDesigner: editItem.marketingDesigner ? 
      {
        id: editItem.marketingDesigner,
        name: editItem.marketingDesignerDisplayText
      } : undefined,
      royaltyDesigner: editItem.royaltyDesigner ? 
      {
        id: editItem.royaltyDesigner,
        name: editItem.royaltyDesignerDisplayText
      } : undefined,
      countryOfOrigin: editItem.countryOfOrigin ? 
      {
        id: editItem.countryOfOrigin,
        name: editItem.countryOfOriginDisplayText
      } : undefined,
      style: editItem.style ? 
      {
        id: editItem.style,
        name: editItem.styleDisplayText
      } : undefined,
      category: editItem.category ? 
      {
        id: editItem.category,
        name: editItem.categoryDisplayText
      } : undefined,
      function: editItem.categoryDisplayText && editItem.function ? 
      {
        id: editItem.function,
        name: editItem.functionDisplayText
      } : undefined,
      skuType: editItem.skuType ? 
      {
        id: editItem.skuType,
        name: editItem.skuTypeDisplayText
      } : undefined,
      stage: editItem.stage ? 
      {
        id: editItem.stage,
        name: editItem.stageDisplayText
      } : undefined,
      status: editItem.stageDisplayText && editItem.status ?
      {
        id: editItem.status,
        name: editItem.statusDisplayText
      } : undefined,
      prop65: editItem.prop65 ?
      {
        id: editItem.prop65,
        description: editItem.prop65DisplayText
      } : undefined,
      primaryFinish: editItem.primaryFinish ?
      {
        id: editItem.primaryFinish,
        name: editItem.primaryFinishName
      } : undefined,
      secondaryFinish: editItem.secondaryFinish ?
      {
        id: editItem.secondaryFinish,
        name: editItem.secondaryFinishName
      } : undefined,
      thirdFinish: editItem.thirdFinish ?
      {
        id: editItem.thirdFinish,
        name: editItem.thirdFinishName
      } : undefined,
      primaryMaterial: editItem.primaryMaterial ? 
      {
        id: editItem.primaryMaterial,
        name: editItem.primaryMaterialDisplayText
      } : undefined,
      secondaryMaterial: editItem.secondaryMaterial ? 
      {
        id: editItem.secondaryMaterial,
        name: editItem.secondaryMaterialDisplayText
      } : undefined,
      thirdMaterial: editItem.thirdMaterial ? 
      {
        id: editItem.thirdMaterial,
        name: editItem.thirdMaterialDisplayText
      } : undefined,
      vendor: editItem.vendor ?
        {
          id: editItem.vendor,
          name: editItem.vendorDisplayText
        } : undefined,
      etlControlNumber: editItem.etlControlNumber ?
        {
          id: editItem.etlControlNumber,
          name: editItem.etlControlNumberDisplayText
        } : undefined,
      ukcaCertificationNumber: editItem.ukcaCertificationNumber
        ? {
          id: editItem.ukcaCertificationNumber,
          name: editItem.ukcaCertificationNumberDisplayText,
        } : undefined,
      customerAssemblyDetail: editItem.customerAssemblyDetail
        ? {
          id: editItem.customerAssemblyDetail,
          name: editItem.customerAssemblyDetailDisplayText,
        }
        : undefined,
      estimatedTimeRequiredForAssembly: editItem.estimatedTimeRequiredForAssembly
        ? {
          id: editItem.estimatedTimeRequiredForAssembly,
          name: editItem.estimatedTimeRequiredForAssemblyDisplayText,
        }
        : undefined,
      patentStatus: editItem.patentStatus
        ? {
          id: editItem.patentStatus,
          name: editItem.patentStatusDisplayText,
        }
        : undefined,
      suggestedNumberOfPeopleRequiredForInstall: editItem.suggestedNumberOfPeopleRequiredForInstall
        ? {
          id: editItem.suggestedNumberOfPeopleRequiredForInstall,
          name: editItem.suggestedNumberOfPeopleRequiredForInstallDisplayText,
        }
        : undefined,
      toolsRequired: editItem.toolsRequired
        ? {
          id: editItem.toolsRequired,
          name: editItem.toolsRequiredDisplayText,
        }
        : undefined,
      warrantyYears: editItem.warrantyYears
        ? {
          id: editItem.warrantyYears,
          name: editItem.warrantyYearsDisplayText,
        }
        : undefined,
      lightKitIncluded: editItem.lightKitIncluded
        ? {
          id: editItem.lightKitIncluded,
          name: editItem.lightKitIncludedDisplayText,
        }
        : undefined,
      masterFinish: editItem.masterFinish
        ? {
          id: editItem.masterFinish,
          name: editItem.masterFinishDisplayText,
        }
        : undefined,
      motorType: editItem.motorType
        ? {
          id: editItem.motorType,
          name: editItem.motorTypeDisplayText,
        }
        : undefined,
      relativeStyle: editItem.relativeStyle
        ? {
          id: editItem.relativeStyle,
          name: editItem.relativeStyleDisplayText,
        }
        : undefined,
      slopeCeiling: editItem.slopeCeiling
        ? {
          id: editItem.slopeCeiling,
          name: editItem.slopeCeilingDisplayText,
        }
        : undefined,
      specialAssembly: editItem.specialAssembly
        ? {
          id: editItem.specialAssembly,
          name: editItem.specialAssemblyDisplayText,
        }
        : undefined,
      swiveling: editItem.swiveling
        ? {
          id: editItem.swiveling,
          name: editItem.swivelingDisplayText,
        }
        : undefined,
      itemRoyaltyCode: editItem.itemRoyaltyCode
        ? {
          id: editItem.itemRoyaltyCode,
          name: editItem.itemRoyaltyCodeDisplayText,
        }
        : undefined,
      batteryLocation: editItem.batteryLocation
        ? {
          id: editItem.batteryLocation,
          name: editItem.batteryLocationDisplayText,
        }
        : undefined,
      batteryQty: editItem.batteryQty
        ? {
          id: editItem.batteryQty,
          name: editItem.batteryQtyDisplayText,
        }
        : undefined,
      bulbBase: editItem.bulbBase
        ? {
          id: editItem.bulbBase,
          name: editItem.bulbBaseDisplayText,
        }
        : undefined,
      bulbColorTemp: editItem.bulbColorTemp
        ? {
          id: editItem.bulbColorTemp,
          name: editItem.bulbColorTempDisplayText,
        }
        : undefined,
      bulbCri: editItem.bulbCri
        ? {
          id: editItem.bulbCri,
          name: editItem.bulbCriDisplayText,
        }
        : undefined,
      bulbIncandescentEquivalentWattage: editItem.bulbIncandescentEquivalentWattage
        ? {
          id: editItem.bulbIncandescentEquivalentWattage,
          name: editItem.bulbIncandescentEquivalentWattageDisplayText,
        }
        : undefined,
      bulbLumen: editItem.bulbLumen
        ? {
          id: editItem.bulbLumen,
          name: editItem.bulbLumenDisplayText,
        }
        : undefined,
      bulbVoltage: editItem.bulbVoltage
        ? {
          id: editItem.bulbVoltage,
          name: editItem.bulbVoltageDisplayText,
        }
        : undefined,
      chargeTime: editItem.chargeTime
        ? {
          id: editItem.chargeTime,
          name: editItem.chargeTimeDisplayText,
        }
        : undefined,
      dimmer: editItem.dimmer
        ? {
          id: editItem.dimmer,
          name: editItem.dimmerDisplayText,
        }
        : undefined,
      ledClass: editItem.ledClass
        ? {
          id: editItem.ledClass,
          name: editItem.ledClassDisplayText,
        }
        : undefined,
      lumensOnHighPower: editItem.lumensOnHighPower
        ? {
          id: editItem.lumensOnHighPower,
          name: editItem.lumensOnHighPowerDisplayText,
        }
        : undefined,
      lumensOnLowPower: editItem.lumensOnLowPower
        ? {
          id: editItem.lumensOnLowPower,
          name: editItem.lumensOnLowPowerDisplayText,
        }
        : undefined,
      lumensOnMedPower: editItem.lumensOnMedPower
        ? {
          id: editItem.lumensOnMedPower,
          name: editItem.lumensOnMedPowerDisplayText,
        }
        : undefined,
      recBulbBothRequired: editItem.recBulbBothRequired
        ? {
          id: editItem.recBulbBothRequired,
          name: editItem.recBulbBothRequiredDisplayText,
        }
        : undefined,
      voltageInput: editItem.voltageInput
        ? {
          id: editItem.voltageInput,
          name: editItem.voltageInputDisplayText,
        }
        : undefined,
      voltageOutput: editItem.voltageOutput
        ? {
          id: editItem.voltageOutput,
          name: editItem.voltageOutputDisplayText,
        }
        : undefined,
      fssPrimaryMaterial: editItem.fssPrimaryMaterial
        ? {
          id: editItem.fssPrimaryMaterial,
          name: editItem.fssPrimaryMaterialDisplayText,
        }
        : undefined,
      fssSecondaryMaterial: editItem.fssSecondaryMaterial
        ? {
          id: editItem.fssSecondaryMaterial,
          name: editItem.fssSecondaryMaterialDisplayText,
        }
        : undefined,
      fssThirdMaterial: editItem.fssThirdMaterial
        ? {
          id: editItem.fssThirdMaterial,
          name: editItem.fssThirdMaterialDisplayText,
        }
        : undefined,
      recommendedRoom1: editItem.recommendedRoom1
        ? {
          id: editItem.recommendedRoom1,
          name: editItem.recommendedRoom1DisplayText,
        }
        : undefined,
      diffuser1FactoryFinishCode: editItem.diffuser1FactoryFinishCode
        ? {
          id: editItem.diffuser1FactoryFinishCode,
          name: editItem.diffuser1FactoryFinishCodeDisplayText,
        }
        : undefined,
      diffuser1Finish: editItem.diffuser1Finish
        ? {
          id: editItem.diffuser1Finish,
          name: editItem.diffuser1FinishDisplayText,
        }
        : undefined,
      diffuser1Material: editItem.diffuser1Material
        ? {
          id: editItem.diffuser1Material,
          name: editItem.diffuser1MaterialDisplayText,
        }
        : undefined,
      diffuser2FactoryFinishCode: editItem.diffuser2FactoryFinishCode
        ? {
          id: editItem.diffuser2FactoryFinishCode,
          name: editItem.diffuser2FactoryFinishCodeDisplayText,
        }
        : undefined,
      diffuser2Finish: editItem.diffuser2Finish
        ? {
          id: editItem.diffuser2Finish,
          name: editItem.diffuser2FinishDisplayText,
        }
        : undefined,
      diffuser2Material: editItem.diffuser2Material
        ? {
          id: editItem.diffuser2Material,
          name: editItem.diffuser2MaterialDisplayText,
        }
        : undefined,
      finishCode: editItem.finishCode
        ? {
          id: editItem.finishCode,
          name: editItem.finishCodeDisplayText,
        }
        : undefined,
      finishDescription: editItem.finishDescription
        ? {
          id: editItem.finishDescription,
          name: editItem.finishDescriptionDisplayText,
        }
        : undefined,
      treatmentMaterial: editItem.treatmentMaterial
        ? {
          id: editItem.treatmentMaterial,
          name: editItem.treatmentMaterialDisplayText,
        }
        : undefined,
      ipFreightClass: editItem.ipFreightClass
        ? {
          id: editItem.ipFreightClass,
          name: editItem.ipFreightClassDisplayText,
        }
        : undefined,
      ipUpsable: editItem.ipUpsable
        ? {
          id: editItem.ipUpsable,
          name: editItem.ipUpsableDisplayText,
        }
        : undefined,
      mpUpsable: editItem.mpUpsable
        ? {
          id: editItem.mpUpsable,
          name: editItem.mpUpsableDisplayText,
        }
        : undefined,
      chainRodFinish: editItem.chainRodFinish
        ? {
          id: editItem.chainRodFinish,
          name: editItem.chainRodFinishDisplayText,
        }
        : undefined,
      connectionType: editItem.connectionType
        ? {
          id: editItem.connectionType,
          name: editItem.connectionTypeDisplayText,
        }
        : undefined,
      glass: editItem.glass
        ? {
          id: editItem.glass,
          name: editItem.glassDisplayText,
        }
        : undefined,
      productType: editItem.productType
        ? {
          id: editItem.productType,
          name: editItem.productTypeDisplayText,
        }
        : undefined,
      websites: editItem.websites
        ? {
          id: editItem.websites,
          name: editItem.websitesDisplayText,
        }
        : undefined,
      reverseSwitchLocation: editItem.reverseSwitchLocation
        ? {
          id: editItem.reverseSwitchLocation,
          name: editItem.reverseSwitchLocationDisplayText,
        }
        : undefined,
      shadeCode: editItem.shadeCode
        ? {
          id: editItem.shadeCode,
          name: editItem.shadeCodeDisplayText,
        }
        : undefined,
      shadeFinishingType: editItem.shadeFinishingType
        ? {
          id: editItem.shadeFinishingType,
          name: editItem.shadeFinishingTypeDisplayText,
        }
        : undefined,
      shadeOuterMaterial: editItem.shadeOuterMaterial
        ? {
          id: editItem.shadeOuterMaterial,
          name: editItem.shadeOuterMaterialDisplayText,
        }
        : undefined,
      shadeTreatment: editItem.shadeTreatment
        ? {
          id: editItem.shadeTreatment,
          name: editItem.shadeTreatmentDisplayText,
        }
        : undefined,
      socketFinishFactoryCode: editItem.socketFinishFactoryCode
        ? {
          id: editItem.socketFinishFactoryCode,
          name: editItem.socketFinishFactoryCodeDisplayText,
        }
        : undefined,
      socketHousingFinish: editItem.socketHousingFinish
        ? {
          id: editItem.socketHousingFinish,
          name: editItem.socketHousingFinishDisplayText,
        }
        : undefined,
      socketHousingMaterial: editItem.socketHousingMaterial
        ? {
          id: editItem.socketHousingMaterial,
          name: editItem.socketHousingMaterialDisplayText,
        }
        : undefined,
      productTrim: editItem.productTrim
        ? {
          id: editItem.productTrim,
          name: editItem.productTrimDisplayText,
        }
        : undefined,
      baseMaterial: editItem.baseMaterial
        ? {
          id: editItem.baseMaterial,
          name: editItem.baseMaterialDisplayText,
        } 
        : undefined,
      itemStatus: editItem.itemStatus.replace(/([a-z])([A-Z])/g, "$1 $2"),
      certiType: editItem.certiType ? { id: editItem.certiType, name: editItem.certiTypeDisplayText } : undefined,
      priMtrlManufMethod: editItem.priMtrlManufMethod ? editItem.priMtrlManufMethod : undefined,
      secMtrlManufMethod: editItem.secMtrlManufMethod ? editItem.secMtrlManufMethod : undefined,
      thirdMtrlManufMethod: editItem.thirdMtrlManufMethod ? editItem.thirdMtrlManufMethod : undefined,
      hardwareMaterial: editItem.hardwareMaterial ? editItem.hardwareMaterial : undefined,
      packaging: editItem.packaging ? editItem.packaging : undefined,
      jBox: editItem.jBox ? { id: editItem.jBox, name: editItem.jBoxDisplayText } : undefined,
      ledColorTemp: editItem.ledColorTemp ? editItem.ledColorTemp : undefined,
      riser: editItem.riser ? editItem.riser : undefined,
      knobType: editItem.knobType ? { id: editItem.knobType, name: editItem.knobTypeDisplayText } : undefined,
      htsMaterial: editItem.htsMaterial ? editItem.htsMaterial : undefined,
      htsMaterialDtl: editItem.htsMaterialDtl ? editItem.htsMaterialDtl : undefined,
      subContVendor1: editItem.subContVendor1 ? editItem.subContVendor1 : undefined,
      subContVendor2: editItem.subContVendor2 ? editItem.subContVendor2 : undefined,
      subContVendor3: editItem.subContVendor3 ? editItem.subContVendor3 : undefined,
      subContVendor4: editItem.subContVendor4 ? editItem.subContVendor4 : undefined,
      subContVendor5: editItem.subContVendor5 ? editItem.subContVendor5 : undefined,
      itemClass: editItem.itemClass ? {id: editItem.itemClass, name: editItem.itemClassDisplayText} : undefined,
      class: editItem.class ? {id: editItem.class, name: editItem.classDisplayText} : undefined,
      relativeTrend: editItem.relativeTrend ? {id: editItem.relativeTrend, name: editItem.relativeTrendDisplayText} : undefined,
      seriesName: editItem.seriesName ? {id: editItem.seriesName, name: editItem.seriesNameDisplayText} : undefined,
      brand: editItem.brand ? {id: editItem.brand, name: editItem.brandDisplayText} : undefined,
      buyerNumber: editItem.buyerNumber ? {id: editItem.buyerNumber, name: editItem.buyerNumberDisplayText} : undefined,
      color: editItem.color ? {id: editItem.color, name: editItem.colorDisplayText} : undefined,
      division: editItem.division ? {id: editItem.division, name: editItem.divisionDisplayText} : undefined,
      engineeringGroup: editItem.engineeringGroup ? {id: editItem.engineeringGroup, name: editItem.engineeringGroupDisplayText} : undefined,
      inventoryStrategy: editItem.inventoryStrategy ? {id: editItem.inventoryStrategy, name: editItem.inventoryStrategyDisplayText} : undefined,
      itemFlashMessage: editItem.itemFlashMessage ? {id: editItem.itemFlashMessage, name: editItem.itemFlashMessageDisplayText} : undefined,
      itemPoolCode: editItem.itemPoolCode ? {id: editItem.itemPoolCode, name: editItem.itemPoolCodeDisplayText} : undefined,
      lampingCode: editItem.lampingCode ? {id: editItem.lampingCode, name: editItem.lampingCodeDisplayText} : undefined,
      ledRoyalty: editItem.ledRoyalty ? {id: editItem.ledRoyalty, name: editItem.ledRoyaltyDisplayText} : undefined,
      plannerNumber: editItem.plannerNumber ? {id: editItem.plannerNumber, name: editItem.plannerNumberDisplayText} : undefined,
      prepackedBanded: editItem.prepackedBanded ? {id: editItem.prepackedBanded, name: editItem.prepackedBandedDisplayText} : undefined,
      purchasingABC: editItem.purchasingABC ? {id: editItem.purchasingABC, name: editItem.purchasingABCDisplayText} : undefined,
      quickShipItem: editItem.quickShipItem ? {id: editItem.quickShipItem, name: editItem.quickShipItemDisplayText} : undefined,
      relatedUnitofMeasure: editItem.relatedUnitofMeasure ? {id: editItem.relatedUnitofMeasure, name: editItem.relatedUnitofMeasureDisplayText} : undefined,
      shippingMethod: editItem.shippingMethod ? {id: editItem.shippingMethod, name: editItem.shippingMethodDisplayText} : undefined,
      unitofMeasure: editItem.unitofMeasure ? {id: editItem.unitofMeasure, name: editItem.unitofMeasureDisplayText} : undefined,
      yearCode: editItem.yearCode ? {id: editItem.yearCode, name: editItem.yearCodeDisplayText} : undefined,
      numberOfTiers: editItem.numberOfTiers ? {id: editItem.numberOfTiers, name: editItem.numberOfTiersDisplayText} : undefined,
      designGrouping: editItem.designGrouping
      ? {
        id: editItem.designGrouping,
        name: editItem.designGroupingDisplayText,
      } 
      : undefined,
      treatmentType: editItem.treatmentType ? { id: editItem.treatmentType, name: editItem.treatmentTypeDisplayText} : undefined,
      treatment: editItem.treatment ? { id: editItem.treatment, name: editItem.treatmentDisplayText} : undefined,
      bladeFinish1: editItem.bladeFinish1 ? { id: editItem.bladeFinish1, name: editItem.bladeFinish1DisplayText} : undefined,
      bladeFinish2: editItem.bladeFinish2 ? { id: editItem.bladeFinish2, name: editItem.bladeFinish2DisplayText} : undefined,
      bulbIncluded: editItem.bulbIncluded ? { id: editItem.bulbIncluded, name: editItem.bulbIncludedDisplayText} : undefined,
      cordColor: editItem.cordColor ? { id: editItem.cordColor, name: editItem.cordColorDisplayText} : undefined,
      canBeInverted: editItem.canBeInverted ? { id: editItem.canBeInverted, name: editItem.canBeInvertedDisplayText} : undefined,
      compatibleLightKit: editItem.compatibleLightKit || [],
      family: editItem.family ? { id: editItem.family, name: editItem.familyDisplayText} : undefined,
      shippingConditionsCode: editItem.shippingConditionsCode ? { id: editItem.shippingConditionsCode, name: editItem.shippingConditionsCodeDisplayText} : undefined,
      applyCommissions: editItem.applyCommissions ? { id: editItem.applyCommissions, name: editItem.applyCommissionsDisplayText} : undefined,
      longItem: editItem.longItem ? { id: editItem.longItem, name: editItem.longItemDisplayText} : undefined,
      itemBranchPreference: editItem.itemBranchPreference ? { id: editItem.itemBranchPreference, name: editItem.itemBranchPreferenceDisplayText} : undefined,
      warehouseProcessGroup: editItem.warehouseProcessGroup ? { id: editItem.warehouseProcessGroup, name: editItem.warehouseProcessGroupDisplayText} : undefined,
      itemPublicationStatus: editItem.itemPublicationStatus ? { id: editItem.itemPublicationStatus, name: editItem.itemPublicationStatusDisplayText} : undefined,
      importDetails: editItem.importDetails ? { id: editItem.importDetails, name: editItem.importDetailsDisplayText} : undefined,
      layerSourceCode: editItem.layerSourceCode ? { id: editItem.layerSourceCode, name: editItem.layerSourceCodeDisplayText} : undefined,
      collectionPricing: editItem.collectionPricing ? { id: editItem.collectionPricing, name: editItem.collectionPricingDisplayText} : undefined,
      manufacturerTransmitterItemNumber: editItem.manufacturerTransmitterItemNumber ? { id: editItem.manufacturerTransmitterItemNumber, name: editItem.manufacturerTransmitterItemNumberDisplayText} : undefined,
      manufacturerReceiverItemNumber: editItem.manufacturerReceiverItemNumber ? { id: editItem.manufacturerReceiverItemNumber, name: editItem.manufacturerReceiverItemNumberDisplayText} : undefined,
      downrodType: editItem.downrodType ? { id: editItem.downrodType, name: editItem.downrodTypeDisplayText} : undefined,
    });

    setDropDownDisabled(editItem);
  };

  useEffect(() => {
    if(editItem) {
      setDropdownValuesFromEditItem();
      setTagValuesFromEditItem();
      setUserAssignmmentsFromEditItem();
    }
  }, [editItem]);

  useEffect(() => {
    // Ensure multi-select UI values are hydrated after picklist options arrive (prevents refresh race)
    if (!editItem) return;
    if (!dropDownOptions?.dataFieldsTypes?.length) return;

    const dropdownObject =
      dropDownOptions.dataFieldsTypes
        ?.find((df) => df.field?.toLowerCase() === dataFieldNames.compatibleLightKit.toLowerCase())
        ?.types?.map((t) => ({ id: t.id, description: t.description, optionLabel: t.optionLabel })) || [];

    const selectedIds = (Array.isArray(editItem.compatibleLightKit) ? editItem.compatibleLightKit : [])
      .map((id) => Number(id))
      .filter((id) => !Number.isNaN(id));

    const hydrated = dropdownObject
      .filter((item) => selectedIds.includes(Number(item?.id)))
      .map((item) => ({ id: item?.id, description: item?.description, optionLabel: item?.optionLabel }));

    setSelectedDropDownOptions((prev) => ({
      ...prev,
      compatibleLightKit: hydrated,
    }));
  }, [dropDownOptions?.dataFieldsTypes, editItem]);

  const resetStateValue = () => {
    formik.resetForm(); 
    setAttachments([]);
    setDeleteAttachmentIds([]);
    setTagMenuOptions([]);
    setSelectedTagOptions([]);
    setSelectedUserAssignments([initialUserAssignment]);
    setFormValueBaseCode("");
    setCommentList([]);
    setAssignmentEditableFields([]);
  };

  const checkItemFormFieldPermission = () => {
    return !sessionService.hasPermission(Permissions.UpdateProduct);
  }

  const checkAssignmentFormFieldPermission = (fieldName: string) => {
    return !(assignmentEditableFields.includes(fieldName))
  };

  const checkBOMPermission = () => {
    return !(sessionService.hasPermission(Permissions.ManageBOM) || sessionService.hasPermission(Permissions.UpdateProduct));
  };

  const checkItemStatus = () => {
    return editItem?.itemStatus == ITEM_STATUS_ENUM.Active
  }

  const isFieldDisabled = (fieldName: string) => {
    if (fieldName === FIELD_NAMES.itemStatus) {
      if(!checkItemFormFieldPermission()) {
        return false;
      } else if (checkItemFormFieldPermission() && !checkAssignmentFormFieldPermission(fieldName)) {
        return false;
      }
    } else {
      if(!checkItemFormFieldPermission() && checkItemStatus()) {
        return false;
      } else if(checkItemFormFieldPermission() && !checkAssignmentFormFieldPermission(fieldName) && checkItemStatus()) {
        return false;
      }
    }

    return true;
  };

  // This function is used to set selected tag options from edit product api
  const setTagValuesFromEditItem = () => {
    if (editItem?.tags && editItem.tags.length > 0) {
      const tagsValue = editItem.tags.map(tag => {
        return {
          id: tag.id,
          name: tag.name
        }
      });
      setSelectedTagOptions(tagsValue);
    }
  };

  // This function is used to set selected user assignment(s) from edit product api
  const setUserAssignmmentsFromEditItem = () => {
    if(editItem?.userAssignments && editItem.userAssignments.length > 0) {
      setSelectedUserAssignments(editItem.userAssignments);
    }
    setFormValueBaseCode(editItem?.baseCode);
  };

  useEffect(() => {
    if(formValueBaseCode?.trim() && formValueBaseCode?.trim() !== editItem?.baseCode?.trim()) {
      fetchUserAssignmentsFromBaseCode(formValueBaseCode, setSelectedUserAssignments, setUserAssignmentsApiRunning, setIsFetchAssignmentsFailed);
    } else if(formValueBaseCode?.trim() && formValueBaseCode?.trim() === editItem?.baseCode?.trim()){
      if(JSON.stringify(selectedUserAssignments) !== JSON.stringify(editItem?.userAssignments)) {
          setUserAssignmmentsFromEditItem();
          setUserAssignmentsApiRunning(false);
      }
    } else if (!formValueBaseCode?.trim()) {
      setSelectedUserAssignments([initialUserAssignment]);
      setUserAssignmentsApiRunning(null);
    }
  }, [formValueBaseCode])

  /**
   * This function is used to set tag menu options
   * @param stageId - Stage Id
   * @param selectedTags - Selected tags
   */
  const prepareTagOptions = (stageId: number, selectedTags: Tag[]) => {
    if (stageId && dropDownOptions?.stageStatusTags?.length) {
      const stageWiseTagOptionsForDropdown = dropDownOptions.stageStatusTags
        .find(stage => stage.id == stageId)
        .tags
        .filter(t => !selectedTags.some((st) => st.id === t.id))
        .map(s => {
          return {
            id: s.id,
            name: s.name
          }
        });
        
      setTagMenuOptions(stageWiseTagOptionsForDropdown);
    }
  };

  /**
   * This function is used to set dropdown field enable / disable based on dependent field value
   * @param item - Edit item state that contains api data
   */
  const setDropDownDisabled = (item: Item) => {
    let disabledItems = [...fieldsDisabled];
    
    if(item.stageDisplayText) {
      const isStatusExists = disabledItems.includes(FIELD_NAMES.status);
      if(isStatusExists) {
        disabledItems = disabledItems.filter(item => item !== FIELD_NAMES.status);
      }
    }
    else {
      const isStatusExists = disabledItems.includes(FIELD_NAMES.status);
      if(!isStatusExists) {
        disabledItems = [...disabledItems, FIELD_NAMES.status];
      }
      formik.setFieldValue(FIELD_NAMES.status, undefined);
    }

    if(item.categoryDisplayText) {
      const isFunctionExists = disabledItems.includes(FIELD_NAMES.function);
      if(isFunctionExists) {
        // Remove the product from the array
        disabledItems = disabledItems.filter(item => item !== FIELD_NAMES.function);
      }
    }
    else {
      const isFunctionExists = disabledItems.includes(FIELD_NAMES.function);
      if(!isFunctionExists) {
        disabledItems = [...disabledItems, FIELD_NAMES.function];
      }
      formik.setFieldValue(FIELD_NAMES.function, undefined);
    }
    setFieldsDisabled(disabledItems);
  };

  /**
   * This function is used to handle Autocomplete dropdown value
   * @param fieldName - Name of the field
   * @param selectedItem - Selected option value
   */
  const handleAutocompleteOptionsChange = (fieldName, selectedItem) => {
    if (!selectedItem) {
      formik.setFieldValue(fieldName, undefined);
      setSelectedDropDownOptions({
        ...selectedDropDownOptions,
        [fieldName]: undefined,
      });

      if (fieldName === FIELD_NAMES.stage) {
        formik.setFieldValue(FIELD_NAMES.status, undefined);
        setSelectedDropDownOptions({...selectedDropDownOptions, [fieldName]: undefined, [FIELD_NAMES.status]: undefined});
        setDropDownFieldDisabled(FIELD_NAMES.status);
        prepareStatusDropDownOptions(null);
      }
      else if (fieldName === FIELD_NAMES.category) {
        formik.setFieldValue(FIELD_NAMES.function, undefined);
        setSelectedDropDownOptions({...selectedDropDownOptions, [fieldName]: undefined, [FIELD_NAMES.function]: undefined});
        setDropDownFieldDisabled(FIELD_NAMES.function);
        prepareFunctionDropDownOptions(null);
      }
    } else {
      /* 
        selectedValue variable logic: 
        if dropdown option contains string type value, then string value will be selected.
        else if Reference fields array includes dropdown field name, then id will be selected.
        else name will be selected.
      */
      let selectedValue =
        typeof selectedItem === "string"
          ? selectedItem
          : REFERENCE_FIELDS_FOR_EDIT_PRODUCT.includes(fieldName)
            ? selectedItem.id
            : selectedItem.name || selectedItem.description;
      
      if(Array.isArray(selectedItem)) {
        selectedValue = selectedItem.map(item => (typeof item === "object" ? item?.id : item));
      }

      formik.setFieldValue(fieldName, selectedValue);

      // Check if the fieldName exists in FIELDS_WITH_DISPLAY_TEXT and set its mapped display field
      if (FIELDS_WITH_DISPLAY_TEXT.hasOwnProperty(fieldName)) {
        formik.setFieldValue(FIELDS_WITH_DISPLAY_TEXT[fieldName], selectedItem.name || selectedItem.description);
      }

      if (fieldName === FIELD_NAMES.stage) {
        formik.setFieldValue(FIELD_NAMES.status, undefined);
        setDropDownFieldEnabled(FIELD_NAMES.status);
        prepareStatusDropDownOptions(selectedItem.id);
        prepareTagOptions(selectedItem.id, selectedTagOptions);
        setSelectedDropDownOptions({...selectedDropDownOptions, [fieldName]: selectedItem, [FIELD_NAMES.status]: undefined});
      }
      else if (fieldName === FIELD_NAMES.category) {
        formik.setFieldValue(FIELD_NAMES.function, undefined);
        setDropDownFieldEnabled(FIELD_NAMES.function);
        prepareFunctionDropDownOptions(selectedItem.id);
        setSelectedDropDownOptions({...selectedDropDownOptions, [fieldName]: selectedItem, [FIELD_NAMES.function]: undefined});
      } else {
        setSelectedDropDownOptions({
          ...selectedDropDownOptions,
          [fieldName]: selectedItem
        });
      }

    }
  };

  const handleAutocompleteMultiSelectChange = (fieldName: string, selectedItems: any[] | null | undefined) => {
    const items = (selectedItems || []).filter(Boolean);
    if (items.length === 0) {
      formik.setFieldValue(fieldName, []);
      setSelectedDropDownOptions({
        ...selectedDropDownOptions,
        [fieldName]: [], 
      });
      return;
    }

    const ids = items
      .map(item => (typeof item === "object" ? item?.id : item))
      .filter((v) => v !== null && v !== undefined && v !== "");

    formik.setFieldValue(fieldName, ids);
    setSelectedDropDownOptions({
      ...selectedDropDownOptions,
      [fieldName]: items,
    });
  };

  /**
   * This function is used to remove array product from state and enable the dropdown field
   * @param fieldName - Name of the field to enable it
   */
  const setDropDownFieldEnabled = (fieldName: string) => {
    const isFieldExists = fieldsDisabled.includes(fieldName);

    if (isFieldExists) {
      // Remove the product from the array
      setFieldsDisabled(fieldsDisabled.filter(sec => sec !== fieldName));
    }
  };

  const setDropDownFieldDisabled = (fieldName: string) => {
    const isFieldExists = fieldsDisabled.includes(fieldName);

    if (!isFieldExists) {
      setFieldsDisabled([...fieldsDisabled, fieldName]);
    }
  };

  const getFieldBackgroundColor = (fieldName) => {
    return isFieldDisabled(fieldName) ? "#EBEBE4" : "#FFFFFF";
  };

  /**
   * This function is used to render text field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
  const renderTextField = (fieldName = "", label = "", disabled = false) => (
    <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
      {!stickyFields.find(field => field.fieldName === fieldName) && <label
        htmlFor={`outlined-${label}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
        {(fieldName === FIELD_NAMES.shortDesc) && <span className="required-field-asterisk-icon">{` *`}</span>}
      </label>}
      <TextField id={`outlined-${label}`}
        name={fieldName}
        margin="dense"
        label={
          formik.touched[fieldName] && formik.errors[fieldName] ?
            formik.errors[fieldName] : (stickyFields.find(field => field.fieldName === fieldName) ? <span className="field-label-container"><span className="field-label">{`${label}`}</span><span className="required-asterisk">{stickyFields.find(field => field.fieldName === fieldName)?.required ? " *" : ""}</span></span> : "")
        }
        value={formik.values[fieldName] || ""}
        onChange={formik.handleChange}
        onBlur={(e) => {
          if(createProductValidations.fields[fieldName]) {
            formik.validateField(fieldName);
          }
          formik.handleBlur(e);
        }}
        error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
        style={{ backgroundColor: getFieldBackgroundColor(fieldName) }}
        disabled={isFieldDisabled(fieldName) || fieldName === "id" || disabled}
      />
    </FormControl>
  );

  const notesFieldRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (isNotesHeightChanged) {
        setIsNotesHeightChanged(false);
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [editItemId])

  useEffect(() => {
    const timer = setTimeout(() => {
      if (notesFieldRef.current) {
        if(!isNotesHeightChanged) {
          setIsNotesHeightChanged(true)
          notesFieldRef.current.style.height = `${defaultNoteHeight}px`;
        }
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [accordianExpanded, editItem]);

  /**
   * This function is used to render text area field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
  const renderTextAreaField = (fieldName = "", label = "", fieldRef: React.MutableRefObject<HTMLTextAreaElement>) => (
    <FormControl key={fieldName} className={`${fieldName} textarea-form-control edit-product-form-control`} style={{ margin: "5px 5px", width: "100%" }}>
      {!stickyFields.find(field => field.fieldName === fieldName) && <label
        htmlFor={`outlined-${label}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
        {(fieldName === FIELD_NAMES.shortDesc) && <span className="required-field-asterisk-icon">{` *`}</span>}
      </label>}
      <TextField id={`outlined-${label}`}
        name={fieldName}
        inputRef={fieldRef}
        inputProps={{
          style: { overflow: "auto" }
        }}
        margin="dense"
        multiline
        minRows={1}
        maxRows={8}
        label={
          formik.touched[fieldName] && formik.errors[fieldName] ?
            formik.errors[fieldName] : (stickyFields.find(field => field.fieldName === fieldName) ? <span className="field-label-container"><span className="field-label">{`${label}`}</span><span className="required-asterisk">{stickyFields.find(field => field.fieldName === fieldName)?.required ? " *" : ""}</span></span> : "")
        }
        value={formik.values[fieldName] || ""}
        onChange={formik.handleChange}
        onBlur={(e) => {
          if(createProductValidations.fields[fieldName]) {
            formik.validateField(fieldName);
          }
          formik.handleBlur(e);
        }}
        error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
        style={{ backgroundColor: getFieldBackgroundColor(fieldName) }}
        disabled={isFieldDisabled(fieldName) || fieldName === "id"}
      />
    </FormControl>
  );

    /**
   * This function is used to render basecode text field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
    const renderTextFieldBaseCodeAuto = (fieldName = "", label = "") => (
      <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
        {!stickyFields.find(field => field.fieldName === fieldName) && <label
          htmlFor={`outlined-${label}`}
          style={{ textTransform: "capitalize" }}
        >
          {label}
          {(fieldName === FIELD_NAMES.shortDesc) && <span className="required-field-asterisk-icon">{` *`}</span>}
        </label>}
        <div className="basecode-field">
          <TextField id={`outlined-${label}`}
            name={fieldName}
            margin="dense"
            label={
              formik.touched[fieldName] && formik.errors[fieldName] ?
                formik.errors[fieldName] : (stickyFields.find(field => field.fieldName === fieldName) ? <span className="field-label-container"><span className="field-label">{`${label}`}</span><span className="required-asterisk">{stickyFields.find(field => field.fieldName === fieldName)?.required ? " *" : ""}</span></span> : "")
            }
            value={formik.values[fieldName] || ""}
            InputProps={!isCopyMode ? { 
              startAdornment:(
                (!checkItemFormFieldPermission() || !checkAssignmentFormFieldPermission(fieldName)) ? <InputAdornment position="start">
                  <AutoAwesomeOutlinedIcon onClick= {() => checkBaseCodeExist ? handleOpenModal() : handleBaseCodeAuto()} sx = {{cursor:"pointer"}}/>
                </InputAdornment> : null),
                endAdornment:
                  (userAssignmentsApiRunning ? <InputAdornment position="end">
                     <Box className="baseCode-loading-box">
                      <CircularProgress color="primary" className="baseCode-loading" />
                     </Box> 
                    </InputAdornment>
                  : null)
            } : undefined}
            style={{ backgroundColor: getFieldBackgroundColor(fieldName) }}
            disabled={isFieldDisabled(fieldName) || isCopyMode}
            onChange={formik.handleChange}
            onBlur={(e) => {
              if(createProductValidations.fields[fieldName]) {
                formik.validateField(fieldName);
              }
              formik.handleBlur(e);
              if(fieldName === FIELD_NAMES.baseCode){
                setFormValueBaseCode(e.target.value);
              }
            }}
            error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
          />
          {isFetchAssignmentsFailed && <Typography color="error">{ASSIGNMENTS_FETCH_WARNING}</Typography>}
        </div>
      </FormControl>
    );

    const handleOpenModal = () => {
      const missingFields = [];
      validateBaseCodeAuto(missingFields);
      if (missingFields.length > 0) {
        toast.error(`${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required to generate Base Code`);
      }else {
        setShowConfirmModal(true);
      }
    };

    const handleCloseModal = () => {
      setShowConfirmModal(false);
      setDeleteModal(false);
    };

    const getFieldLabel = (fieldName) => {
      if (productLayoutFields?.length > 0) {
        // Flatten fields array from the productLayoutFields state
        let flattenedFields = productLayoutFields.flatMap(category => category.fields);
        let fieldLabel;

        flattenedFields.find((fl) => {
          if (fl.fieldName === fieldName) {
            fieldLabel = fl.label;
          }
        });
        return fieldLabel || fieldName;
      }
    };

    const validateBaseCodeAuto = (missingFields) => {
      const { marketingDesigner, seriesName, category, seriesNameDisplayText } = formik.values;

      if (!marketingDesigner) {
        missingFields.push(getFieldLabel(FIELD_NAMES.marketingDesigner));
      };
      if (!seriesName && !seriesNameDisplayText) {
        missingFields.push(getFieldLabel(FIELD_NAMES.seriesName));
      };
      if (!category) {
        missingFields.push(getFieldLabel(FIELD_NAMES.category));
      };
    };
  
    const handleBaseCodeAuto = async () => {
      try {
        const missingFields = [];
        validateBaseCodeAuto(missingFields);
        if (missingFields.length > 0) {
          return toast.error(`${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required to generate Base Code`);
        }
        const baseCodeAutoResponse = await api.post<ApiResponse<any>>("/Item/base-code-automation", {
          marketingDesigner: formik.values.marketingDesigner,
          seriesName: formik.values.seriesName,
          seriesNameDisplayText: formik.values.seriesNameDisplayText,
          category: formik.values.category,
        })
        if (baseCodeAutoResponse.isSuccess) {
          formik.setFieldValue(FIELD_NAMES.baseCode, baseCodeAutoResponse?.data?.baseCode);
          if (!(formik.values.pdCode)) {
            formik.setFieldValue(FIELD_NAMES.pdCode, baseCodeAutoResponse?.data?.baseCode);
          }
          formik.setFieldValue(FIELD_NAMES.bC_DesignerSeq, baseCodeAutoResponse?.data?.designerSeqNo);
          formik.setFieldValue(FIELD_NAMES.bC_CategorySeq, baseCodeAutoResponse?.data?.categorySeqNo);
          formik.setFieldValue(FIELD_NAMES.seriesName, baseCodeAutoResponse?.data?.seriesName);
          setSelectedDropDownOptions({
            ...selectedDropDownOptions,
            seriesName: {id: baseCodeAutoResponse?.data?.seriesName, name: formik?.values?.seriesNameDisplayText}
          });
          toast.success(baseCodeAutoResponse.message);
          setShowConfirmModal(false);
        }
      } catch (error: any) {
        toast.error(error.message);
      }
    };

    /**
     * This function is used to handle numeric text field value
     * @param fieldName - Name of the field
     * @param value - Value of the field
     */
    const handleNumericFieldChange = (fieldName: string, value: string | number) => {
      if (value === "") {
        formik.setFieldValue(fieldName, null);
      }
      else {
        formik.setFieldValue(fieldName, value);
      }
    };


  /**
   * This function is used to render numeric text field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   * @param isInteger - Whether the field should only accept integer values
   */
  const renderNumericField = (fieldName = "", label = "", isInteger = false) => (
    <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
      {!stickyFields.find(field => field.fieldName === fieldName) && <label
        htmlFor={`outlined-${label}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
      </label>}
      <TextField
        id={`outlined-${label}`}
        name={fieldName}
        className="hide-input-arrow"
        inputProps={{ type: "number", step: isInteger ? 1 : "any" }}
        margin="dense"
        onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()}
        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
        label={
          formik.touched[fieldName] && formik.errors[fieldName] ?
            formik.errors[fieldName] : (stickyFields.find(field => field.fieldName === fieldName) ? <span className="field-label-container"><span className="field-label">{`${label}`}</span><span className="required-asterisk">{stickyFields.find(field => field.fieldName === fieldName)?.required ? " *" : ""}</span></span> : "")
        }
        value={formik.values[fieldName] || ""}
        onChange={(e) => {
          handleNumericFieldChange(fieldName, e.target.value);
        }}
        onBlur={(e) => {
          if(createProductValidations.fields[fieldName]) {
            formik.validateField(fieldName);
          }
          formik.handleBlur(e);
        }}
        error={formik.touched[fieldName] && Boolean(formik.errors[fieldName])}
        style={{ backgroundColor:  (disableOnQuotesFields.includes(fieldName) && !!formik?.values?.quoteId) ? "#EBEBE4" : getFieldBackgroundColor(fieldName) }}
        disabled={(disableOnQuotesFields.includes(fieldName) && !!formik?.values?.quoteId) || isFieldDisabled(fieldName)}
      />
    </FormControl>
  );

  const getSortedValues = (arr, isDes: boolean = false) => {
    if (arr.length > 0) {
        if (typeof arr[0] === "string") {
            return arr?.sort((a, b) => isDes ? b.localeCompare(a) : a.localeCompare(b))?.join('; ');
        };
        const sortKey = "description";
        return arr?.sort(sortByKey(sortKey))?.map(item => item?.optionLabel || item?.description).join('; ');
    }
    return '';
  };

  /**
   * This function is used to render autocomplete with dropdown option list
   * @param fieldName - Name of the field
   * @param label - Label of the field
   * @param optionList - Dropdown option array list
   * @param optionLabelGetter - Custom label for dropdown option list
   */
  const renderAutocomplete = (
    fieldName: string = "",
    label: string = "",
    optionList: Array<any> | undefined,
    optionLabelGetter: (option) => string = null,
    isMultiSelect: boolean = false
  ) => {
    const searchValue = multiSelectSearchTerms[fieldName] || "";
    const getOptionText = (option: any) => {
      if (optionLabelGetter) {
        return optionLabelGetter(option)?.toString?.() || "";
      }
      const matchedOption = option?.id != null
        ? (optionList || []).find((item: any) => item?.id === option?.id)
        : undefined;
      const label = matchedOption?.optionLabel || option?.optionLabel || option?.name || option?.description || option || "";
      return label?.toString?.() || "";
    };

    const selectedItems: any[] = (() => {
      const fromState = selectedDropDownOptions[fieldName];
      if (Array.isArray(fromState)) return fromState;
      if (fromState === undefined) {
        const hydrated = isMultiSelect ? setValuesOfMultiSelectFields(fieldName) || [] : [];
        return Array.isArray(hydrated) ? hydrated : [];
      }
      // Defensive: multi-select must always be an array
      return [];
    })();

    const selectedIds = new Set((selectedItems || [])?.map((v: any) => (typeof v === "object" ? v?.id : v)));
    const disabled = isFieldDisabled(fieldName) || fieldsDisabled.includes(fieldName) || (isCopyMode && fieldName === FIELD_NAMES.marketingDesigner);

    if (isMultiSelect) {
      const open = !!multiSelectDialogOpen[fieldName];
      const allOptions = optionList || [];
      const term = (searchValue || "").trim().toLowerCase();
      const filteredOptions = term
        ? allOptions.filter((opt: any) => getOptionText(opt).toLowerCase().includes(term))
        : allOptions;

      return (
        <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
          {!stickyFields.find(field => field.fieldName === fieldName) && <label
            htmlFor={`outlined-${fieldName}`}
            style={{ textTransform: "capitalize" }}
          >
            {label}
            {([FIELD_NAMES.brandCollection, FIELD_NAMES.developmentType].includes(fieldName)) && <span className="required-field-asterisk-icon">{` *`}</span>}
          </label>}

          <TextField
            id={`outlined-${fieldName}`}
            className="truncated-dropdown-value"
            placeholder="- Select -"
            value={selectedItems?.length ? getSortedValues([...selectedItems], false) : ""}
            onClick={(e) => {
              if (disabled) return;
              setMultiSelectAnchorEls((prev) => ({ ...prev, [fieldName]: e.currentTarget as HTMLElement }));
              setMultiSelectDialogOpen((prev) => ({ ...prev, [fieldName]: true }));
            }}
            inputProps={{
              readOnly: true,
              'aria-readonly': true,
              title: selectedItems?.length ? getSortedValues([...selectedItems], false) : "",
            }}
            disabled={disabled}
            style={{ backgroundColor: getFieldBackgroundColor(fieldName) }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <ArrowDropDownIcon />
                </InputAdornment>
              ),
            }}
          />

          <Popper
            open={open}
            anchorEl={multiSelectAnchorEls[fieldName]}
            placement="bottom-start"
            style={{ zIndex: 1300 }}
            modifiers={[
              { name: "offset", options: { offset: [0, 6] } },
              { name: "sameWidth", enabled: true, phase: "beforeWrite", requires: ["computeStyles"], fn: ({ state }) => {
                state.styles.popper.width = `${state.rects.reference.width}px`;
              }},
            ]}
          >
            <ClickAwayListener
              onClickAway={() => {
                setMultiSelectDialogOpen((prev) => ({ ...prev, [fieldName]: false }));
                setMultiSelectAnchorEls((prev) => ({ ...prev, [fieldName]: null }));
              }}
            >
              <Paper
                elevation={4}
                onKeyDown={(e) => {
                  if (e.key === "Escape") {
                    setMultiSelectDialogOpen((prev) => ({ ...prev, [fieldName]: false }));
                    setMultiSelectAnchorEls((prev) => ({ ...prev, [fieldName]: null }));
                  }
                }}
                style={{ padding: 8 }}
              >

                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search here"
                  value={searchValue}
                  autoFocus
                  onChange={(e) =>
                    setMultiSelectSearchTerms((prev) => ({
                      ...prev,
                      [fieldName]: e.target.value,
                    }))
                  }
                  sx={{ mb: 1 }}
                />

                <List dense sx={{ maxHeight: 320, overflow: "auto" }}>
                  {dropdownOptionsLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" py={2}>
                      <CircularProgress size={24} />
                    </Box>
                  ) : filteredOptions.length === 0 ? (
                    <ListItemText
                      primary="No data found"
                      sx={{ px: 2, py: 1, color: "text.secondary" }}
                    />
                  ) : (
                    filteredOptions.map((opt: any) => {
                      const id = opt?.id ?? opt;
                      const checked = selectedIds.has(id);
                      return (
                        <ListItemButton
                          key={id}
                          selected={checked}
                          title={getOptionText(opt)}
                          onClick={() => {
                            const next = checked
                              ? (selectedItems || []).filter((x: any) => (typeof x === "object" ? x?.id : x) !== id)
                              : [...(selectedItems || []), opt];
                            handleAutocompleteMultiSelectChange(fieldName, next);
                          }}
                        >
                          <ListItemText
                            primary={getOptionText(opt)}
                            primaryTypographyProps={{ noWrap: true }}
                          />
                        </ListItemButton>
                      );
                    })
                  )}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper>
        </FormControl>
      );
    }

    return (
      <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
        {!stickyFields.find(field => field.fieldName === fieldName) && <label
          htmlFor={`outlined-${fieldName}`}
          style={{ textTransform: "capitalize" }}
        >
          {label}
          {([FIELD_NAMES.brandCollection, FIELD_NAMES.developmentType ].includes(fieldName)) && <span className="required-field-asterisk-icon">{` *`}</span>}
        </label>}
        <Autocomplete
          id={`outlined-${fieldName}`}
          multiple={false}
          value={selectedDropDownOptions[fieldName] !== undefined ? selectedDropDownOptions[fieldName] : null}
          onChange={(event, newValue) => handleAutocompleteOptionsChange(fieldName, newValue)}
          onBlur={(e) => {
            if(createProductValidations.fields[fieldName]) {
              formik.validateField(fieldName);
            }
            formik.handleBlur(e);
          }}
          options={dropdownOptionsLoading ? [] : (optionList || [])}
          loading={dropdownOptionsLoading}
          getOptionLabel={(option) => getOptionText(option)}
          renderOption={(props, option) => {
            const optionText = getOptionText(option);
            return (
              <li {...props} key={option?.id || props.id} title={optionText}>
                {optionText}
              </li>
            );
          }}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          style={{ backgroundColor: getFieldBackgroundColor(fieldName) }}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              error={Boolean(formik.errors[fieldName])}
              label={formik.errors[fieldName] ? formik.errors[fieldName] : (stickyFields.find(field => field.fieldName === fieldName) ? <span className="field-label-container"><span className="field-label">{`${label}`}</span><span className="required-asterisk">{stickyFields.find(field => field.fieldName === fieldName)?.required ? " *" : ""}</span></span> : "")}
              key={params.id}
              {...params}
              placeholder="- Select -"
              inputProps={{
                ...params.inputProps,
                title: getInputTitle(params.inputProps?.value),
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {dropdownOptionsLoading ? <CircularProgress color="inherit" size={18} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </FormControl>
    );
  };

  /**
   * This function is used to render select dropdown option list
   * @param fieldName - Name of the field
   * @param label - Label of the field
   * @param optionList - Dropdown option array list
   */
  const renderDropDown = (
    fieldName: string = "",
    label: string = "",
    optionList: Array<any> | undefined
  ) => (
    <FormControl key={fieldName} className={stickyFields?.find(field => field.fieldName === fieldName) ? "sticky-field-dropdown" : ""} style={{ margin: "5px 5px", width: "100%" }}>
      <label
        htmlFor={`outlined-${fieldName}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
      </label>
      <Select
        id={`outlined-${fieldName}`}
        label={stickyFields?.find(field => field.fieldName === fieldName) ? label : undefined}
        name={fieldName}
        type="text"
        onBlur={(e) => {
          if(createProductValidations.fields[fieldName]) {
            formik.validateField(fieldName);
          }
          formik.handleBlur(e);
        }}
        value={formik.values[fieldName] || ""}
        displayEmpty={true}
        onChange={(event, selectedItem: any) =>{
          handleDropDownOptionsChange(fieldName, selectedItem.props)
        }}
        disabled={(fieldName !== FIELD_NAMES.bomType  && (fieldsDisabled.includes(fieldName) || isFieldDisabled(fieldName))) || (fieldName === FIELD_NAMES.bomType && checkBOMPermission())}
        SelectDisplayProps={{
          title: (() => {
            const selected = optionList?.find((item) => item.id === formik.values[fieldName]);
            return getInputTitle(selected?.description || selected?.name || selected?.bomDescription);
          })(),
        }}
        sx={{
          height: "45px",
          margin: "5px 0",
          backgroundColor: ((fieldName !== FIELD_NAMES.bomType  && (fieldsDisabled.includes(fieldName) || isFieldDisabled(fieldName))) || (fieldName === FIELD_NAMES.bomType && checkBOMPermission())) ? "#EBEBE4" : "#FFFFFF"
        }}
      >
        <MenuItem value="" disabled>Select</MenuItem>
        {optionList && optionList.length > 0 &&
          optionList.map((item) => {
            const optionText = item.description || item.name || item.bomDescription;
            return (
              <MenuItem key={item.id} value={item.id} title={optionText}>
                {/* since item type is any, this is required to get the data field out */}
                {optionText}
              </MenuItem>
            );
          })}
          <MenuItem value={null}>None</MenuItem>
      </Select>
    </FormControl>
  );

   /**
   * This function is used to render toogle switch button field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
   const renderToggleButton = (
    fieldName: string = "",
    label: string = "",
  ) => (
    <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
      <label
        htmlFor={`outlined-${fieldName}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
      </label>
      <FormControlLabel
         control={
           <ToggleSwitchButton
             checked={formik.values[fieldName]}
             onChange={(e) => formik.setFieldValue(fieldName, e.target.checked)}
             fieldName={fieldName}
             readOnlyField={isFieldDisabled(fieldName)}
           />
         }
        label={formik.values[fieldName] ? "Yes" : "No"}
      />
    </FormControl>
  );

  /**
   * This function is used to render boolean radio buttons field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
  const renderBooleanRadioButtons = (
    fieldName: string = "",
    label: string = "",
  ) => (
    <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
      <label
        htmlFor={`outlined-${fieldName}`}
        style={{ textTransform: "capitalize" }}
      >
        {label}
      </label>
      <RadioGroup
        id={`radio-group-${fieldName}`}
        name={fieldName}
        value={formik.values[fieldName]}
        onChange={(e) => {
          const radioValue = e.target.value === "true" ? true : e.target.value === "false" ? false : null;
          return formik.setFieldValue(fieldName, radioValue)

        }}
        className="boolean-radio-buttons"
      >
        <FormControlLabel value={null} control={<Radio />} label="Not Set" />
        <FormControlLabel value={true} control={<Radio />} label="True" />
        <FormControlLabel value={false} control={<Radio />} label="False" />
      </RadioGroup>
    </FormControl>
  );

   /**
   * This function is used to render date picker field
   * @param fieldName - Name of the field
   * @param label - Label of the field
   */
   const renderDatePicker = (
    fieldName: string = "",
    label: string = "",
    options: { showTBD?: boolean } = {},
  ) => {
    const fieldValue = formik.values[fieldName];
    const isTBD = options.showTBD && !!formik.values[FIELD_NAMES.isSLIntroDateTBD];
    const isDisabled = isFieldDisabled(fieldName);
    const dateValue = fieldValue ? moment(fieldValue).format("YYYY-MM-DD") : "";

    return (
      <FormControl key={fieldName} style={{ margin: "5px 5px", width: "100%" }}>
        <label htmlFor={`outlined-${fieldName}`}>
          {label}
        </label>
        {options.showTBD && (
          <FormControlLabel
            sx={{
              marginLeft: '-16px',
              width: '0 !important',
              justifyContent: 'end'
            }}
            control={
              <Checkbox
                checked={isTBD}
                disabled={isDisabled}
                onChange={(e) => {
                  const checked = e.target.checked;
                  formik.setFieldValue(FIELD_NAMES.isSLIntroDateTBD, checked);
                  if (checked) {
                    formik.setFieldValue(fieldName, null);
                  }
                }}
              />
            }
            label="TBD"
          />
        )}
        <TextField
          id={`outlined-${fieldName}`}
          type="date"
          name={fieldName}
          value={dateValue}
          onChange={(e) => {
            const value = e.target.value;
            formik.setFieldValue(
              fieldName,
              value ? moment(value, "YYYY-MM-DD").toDate() : null
            );
          }}
          onBlur={(e) => {
            if (createProductValidations.fields[fieldName]) {
              formik.validateField(fieldName);
            }
            formik.handleBlur(e);
          }}
          style={{ marginTop: "5px", backgroundColor: getFieldBackgroundColor(fieldName) }}
          disabled={isDisabled || isTBD}
        />
      </FormControl>
    );
  };

  /**
   * This function is used to handle Select dropdown value
   * @param fieldName - Name of the field
   * @param selectedItem - Selected option value
   */
  const handleDropDownOptionsChange = (fieldName, selectedItem) => {
    const selectedValue =
      typeof selectedItem === "string"
        ? selectedItem
        : REFERENCE_FIELDS_FOR_EDIT_PRODUCT.includes(fieldName)
          ? selectedItem.value
          : selectedItem.children;
    formik.setFieldValue(fieldName, selectedValue);

    // Check if the fieldName exists in FIELDS_WITH_DISPLAY_TEXT and set its mapped display field
    if (FIELDS_WITH_DISPLAY_TEXT.hasOwnProperty(fieldName)) {
      formik.setFieldValue(FIELDS_WITH_DISPLAY_TEXT[fieldName], selectedItem?.children);
    }

    if (fieldName === FIELD_NAMES.stage) {
      formik.setFieldValue(FIELD_NAMES.status, undefined);
      setDropDownFieldEnabled(FIELD_NAMES.status);
      prepareStatusDropDownOptions(selectedItem.id);
      prepareTagOptions(selectedItem.value, selectedTagOptions);
    }
    else if (fieldName === FIELD_NAMES.category) {
      formik.setFieldValue(FIELD_NAMES.function, undefined);
      setDropDownFieldEnabled(FIELD_NAMES.function);
      prepareFunctionDropDownOptions(selectedItem.id);
    }
  };

   /**
   * This function is used to returns list of DataTypes for a given field name
   * @param attributeName - Api response field name
   */
   const getAttributeValues = (attributeName: string) => {
    if(dropDownOptions && dropDownOptions.dataFieldsTypes) {
      return dropDownOptions.dataFieldsTypes
            ?.find(df => df.field.toLowerCase() === attributeName.toLowerCase())
            ?.types
            ?.map(t => {
              return {
                id: t.id,
                description: t.description,
                optionLabel: t.optionLabel,
              }
            });
    }
    else return [];
  };

  /**
   * This function is used to set status dropdown options based on stage field selection
   * @param stageId - Stage field api data
   */
  const prepareStatusDropDownOptions = (stageId: number) => {
    if (stageId && dropDownOptions?.stageStatusTags?.length) {
      const statusDropDownOptions = dropDownOptions.stageStatusTags
        .find(stage => stage.id == stageId)
        .statuses
        .map(s => {
          return {
            id: s.id,
            name: s.description,
            value: s.id
          }
        })
        .sort(sortByKey("name"));
        
      setStatusDropDownOptions(statusDropDownOptions);
    } else {
      setStatusDropDownOptions([]);
    }
  };

  /**
   * This function is used to set function dropdown options based on category field selection
   * @param categoryName - Category display text field api data
   * @param dropDownItem - Selected dropdown value of Category field
   */
  const prepareFunctionDropDownOptions = (categoryId: number) => {
    if (categoryId && dropDownOptions?.productFunctions?.length) {
      const functionDropDownOptions = dropDownOptions.productFunctions
        .filter(func => func.category == categoryId)
        .map(item => {
          return {
            id: item.id,
            name: item.description,
            value: item.id,
            leagoCode: item.leagoCode,
            optionLabel: item.optionLabel
              || (item.leagoCode?.trim()
                ? `${item.description?.trim()} (${item.leagoCode.trim()})`
                : item.description),
          }
        });
      setFunctionDropDownOptions(functionDropDownOptions);
    } else {
      setFunctionDropDownOptions([]);
    }
  };

  // List of fields with HTML renderer
  const formFieldsRenderer = {
      // START: New CVL Fields
      baseShape: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.baseShape)),
      batteryType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.batteryType)),
      brandCollection: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.brandCollection)),
      bulbShape: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbShape)),
      bulbShapeCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbShapeCode)),
      canopyShape: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.canopyShape)),
      category: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productcategories),
      certiNote: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.certiNote)),
      colorTemperature: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.colorTemperature)),
      cri: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.cri)),
      department: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.department)),
      ledDimmingType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ledDimmingType)),
      driverLocation: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.driverLocation)),
      ledDriverType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ledDriverType)),
      ledType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ledType)),
      lightSource: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lightSource)),
      locationRating: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.locationRating)),
      mountingType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.mountingType)),
      reportingBrand: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.reportingBrand)),
      socketType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketType)),
      socket1Type: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketType)),
      socket2Type: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketType)),
      socket3Type: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketType)),
      wireColor: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.wireColor)),
      skuRank: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.sKURank)),
      bcRank: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.sKURank)),
      vendorMOQType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.vendorMOQType)),
      itemStockingType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemStockingType)),
      warehouse: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.warehouse)),
      slStatus: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.sLStatus)),
      primaryFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes,
        (option) => `${option.name}`),
      secondaryFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes,
        (option) => `${option.name}`),
      thirdFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes,
        (option) => `${option.name}`),
      developmentType: (field) => () => renderAutocomplete(field.fieldName, field.label, DEVELOPMENT_TYPE_DROPDOWN_OPTIONS),
      countryOfOrigin: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.countryOfOrigin)),
      // END: New CVL Fields
      // START: New Remaining CVL Fields
      etlControlNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.etlControlNumber)),
      ukcaCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      ukcaCertificationNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ukcaCertificationNumber)),
      customerAssemblyDetail: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.customerAssemblyDetail)),
      estimatedTimeRequiredForAssembly: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.estimatedTimeRequiredForAssembly)),
      patentStatus: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.patentStatus)),
      suggestedNumberOfPeopleRequiredForInstall: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.suggestedNumberOfPeopleRequiredForInstall)),
      toolsRequired: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.toolsRequired)),
      warrantyYears: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.warrantyYears)),
      lightKitIncluded: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lightKitIncluded)),
      masterFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.masterFinish)),
      motorType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.motorType)),
      relativeStyle: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.relativeStyle)),
      slopeCeiling: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.slopeCeiling)),
      specialAssembly: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.specialAssembly)),
      swiveling: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.swiveling)),
      itemRoyaltyCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemRoyaltyCode)),
      batteryLocation: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.batteryLocation)),
      batteryQty: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.batteryQty)),
      bulbBase: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbBase)),
      bulbColorTemp: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbColorTemp)),
      bulbCri: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbCri)),
      bulbIncandescentEquivalentWattage: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbIncandescentEquivalentWattage)),
      bulbLumen: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbLumen)),
      bulbVoltage: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbVoltage)),
      chargeTime: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.chargeTime)),
      dimmer: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.dimmer)),
      ledClass: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ledClass)),
      lumensOnHighPower: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lumensOnHighPower)),
      lumensOnLowPower: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lumensOnLowPower)),
      lumensOnMedPower: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lumensOnMedPower)),
      recBulbBothRequired: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.recBulbBothRequired)),
      voltageInput: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.voltageInput)),
      voltageOutput: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.voltageOutput)),
      fssPrimaryMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.fssPrimaryMaterial)),
      fssSecondaryMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.fssSecondaryMaterial)),
      fssThirdMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.fssThirdMaterial)),
      recommendedRoom1: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.recommendedRoom1)),
      diffuser1FactoryFinishCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser1FactoryFinishCode)),
      diffuser1Finish: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser1Finish)),
      diffuser1Material: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser1Material)),
      diffuser2FactoryFinishCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser2FactoryFinishCode)),
      diffuser2Finish: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser2Finish)),
      diffuser2Material: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.diffuser2Material)),
      finishCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.finishCode)),
      finishDescription: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.finishDescription)),
      treatmentMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.treatmentMaterial)),
      ipFreightClass: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ipFreightClass)),
      ipUpsable: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ipUpsable)),
      mpUpsable: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.mpUpsable)),
      chainRodFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.chainRodFinish)),
      connectionType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.connectionType)),
      glass: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.glass)),
      productType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.productType)),
      websites: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.websites)),
      reverseSwitchLocation: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.reverseSwitchLocation)),
      shadeCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shadeCode)),
      shadeFinishingType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shadeFinishingType)),
      shadeOuterMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shadeOuterMaterial)),
      shadeTreatment: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shadeTreatment)),
      socketFinishFactoryCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketFinishFactoryCode)),
      socketHousingFinish: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes),
      socketHousingMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.socketHousingMaterial)),
      productTrim: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.productTrim)),
      // END: New Remaining CVL Fields
      certiType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.certiType)),
      height: (field) => () => renderNumericField(field.fieldName, field.label),
      width: (field) => () => renderNumericField(field.fieldName, field.label),
      canopy: (field) => () => renderTextField(field.fieldName, field.label),
      fixture_Height: (field) => () => renderNumericField(field.fieldName, field.label),
      height_min: (field) => () => renderNumericField(field.fieldName, field.label),
      jBox: (field) => () => renderAutocomplete(field.fieldName,field.label, getAttributeValues(dataFieldNames.jBox)),
      oaHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      rpm: (field) => () => renderNumericField(field.fieldName, field.label, true),
      style: (field) => () => renderAutocomplete(field.fieldName,field.label, dropDownOptions.styles),
      romanticSize: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.romanticSize)),
      designGrouping: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.designGrouping)),
      stockcode: (field) => () => renderTextField(field.fieldName, field.label),
      longDesc: (field) => () => renderTextField(field.fieldName, field.label),
      pdFamilyName: (field) => () => renderTextField(field.fieldName, field.label),
      shortDesc: (field) => () => renderTextField(field.fieldName,field.label),
      // familyName: (field) => () => renderTextField(field.fieldName, field.label),
      function: (field) => () => renderAutocomplete(field.fieldName,field.label, functionDropDownOptions),    
      shortDescPrv: (field) => () => renderTextField(field.fieldName, field.label),
      pdCode: (field) => () => renderTextField(field.fieldName, field.label, isCopyMode),
      stage: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.stageStatusTags),
      status: (field) => () => renderAutocomplete(field.fieldName, field.label, statusDropDownOptions),
      stockcodePrv: (field) => () => renderTextField(field.fieldName, field.label),
      basecodePrv: (field) => () => renderTextField(field.fieldName, field.label),
      royaltyDesigner: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.royaltyDesigners),
      marketingDesigner: (field) => () => renderAutocomplete(field.fieldName,field.label, dropDownOptions.productDesignerMkts),
      groupName: (field) => () => renderTextField(field.fieldName, field.label),
      socketQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      socketDtl: (field) => () => renderTextField(field.fieldName, field.label),
      ledLumens: (field) => () => renderTextField(field.fieldName, field.label),
      assembly: (field) => () => renderTextField(field.fieldName, field.label),
      priMtrlManufMethod: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.maufacturingMethods),
      secMtrlManufMethod: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.maufacturingMethods),
      thirdMtrlManufMethod: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.maufacturingMethods),
      fourACDesc: (field) => () => renderTextField(field.fieldName, field.label),
      primaryMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.primaryMaterials),
      secondaryMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.primaryMaterials),
      treatmentType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.treatmentType)),
      treatment: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.treatment)),
      thirdMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.primaryMaterials),
      skuType: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.skuTypes),
      shadeDesc: (field) => () => renderTextField(field.fieldName, field.label),
      wiringDtl: (field) => () => renderTextField(field.fieldName, field.label),
      candleTubeHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      finialMaterial: (field) => () => renderTextField(field.fieldName, field.label),
      hardwareMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.primaryMaterials),
      rod_Count: (field) => () => renderNumericField(field.fieldName, field.label, true),
      rod_Diameter: (field) => () => renderTextField(field.fieldName, field.label),
      break_count: (field) => () => renderNumericField(field.fieldName, field.label, true),
      break_length: (field) => () => renderTextField(field.fieldName, field.label),
      rod_Shape: (field) => () => renderTextField(field.fieldName, field.label),
      knobType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.knobType)),
      finialFinishCd: (field) => () => renderTextField(field.fieldName, field.label),
      baseMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.primaryMaterials),
      factoryItemNum: (field) => () => renderTextField(field.fieldName, field.label),
      factShadeGlassCode: (field) => () => renderTextField(field.fieldName, field.label),
      htsMaterial: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.htsMaterials),
      htsMaterialDtl: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.htsMaterialDetails),
      subContVendor1: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      subContVendor1FactoryItem: (field) => () => renderTextField(field.fieldName, field.label),
      subContVendor2: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      subContVendor2FactoryItem: (field) => () => renderTextField(field.fieldName, field.label),
      subContVendor3: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      subContVendor3FactoryItem: (field) => () => renderTextField(field.fieldName, field.label),
      subContVendor4: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      subContVendor4FactoryItem: (field) => () => renderTextField(field.fieldName, field.label),
      subContVendor5: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      subContVendor5FactoryItem: (field) => () => renderTextField(field.fieldName, field.label),
      // New String Fields:
      allThreadType: (field) => () => renderTextField(field.fieldName, field.label),
      assemblyDetail: (field) => () => renderTextField(field.fieldName, field.label),
      backplateShape: (field) => () => renderTextField(field.fieldName, field.label),
      baseCode: (field) => () => renderTextFieldBaseCodeAuto(field.fieldName, field.label),
      basecodeDescription: (field) => () => renderTextField(field.fieldName, field.label),
      binning: (field) => () => renderTextField(field.fieldName, field.label),
      bladeFinish1: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes,
        (option) => `${option.name}`),
      bladeFinish2: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.fixtureFinishes,
        (option) => `${option.name}`),
      bulbInBox1: (field) => () => renderTextField(field.fieldName, field.label),
      bulbWattage: (field) => () => renderNumericField(field.fieldName, field.label, true),
      candleTubeFinish: (field) => () => renderTextField(field.fieldName, field.label),
      cbCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      cccCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      ceCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      chainLength: (field) => () => renderTextField(field.fieldName, field.label),
      compatibleLightKit: (field) => () =>
        renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.compatibleLightKit), undefined, true),
      copyFreeForm: (field) => () => renderTextField(field.fieldName, field.label),
      cordColor: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.cordColor)),
      cordCoverLength: (field) => () => renderTextField(field.fieldName, field.label),
      cordCoverTotalLength: (field) => () => renderTextField(field.fieldName, field.label),
      cordLength: (field) => () => renderTextField(field.fieldName, field.label),
      couplingWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      criticalToQuality: (field) => () => renderTextField(field.fieldName, field.label),
      depth: (field) => () => renderTextField(field.fieldName, field.label),
      driverDimensions: (field) => () => renderTextField(field.fieldName, field.label),
      eacCertificateNumber: (field) => () => renderTextField(field.fieldName, field.label),
      emcCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      energyStarCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      etlCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      extension: (field) => () => renderTextField(field.fieldName, field.label),
      factoryFinishCode: (field) => () => renderTextField(field.fieldName, field.label),
      fcCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      feature1: (field) => () => renderTextField(field.fieldName, field.label),
      feature2: (field) => () => renderTextField(field.fieldName, field.label),
      feature3: (field) => () => renderTextField(field.fieldName, field.label),
      finialFinish: (field) => () => renderTextField(field.fieldName, field.label),
      hardwareFinish: (field) => () => renderTextField(field.fieldName, field.label),
      harpFinish: (field) => () => renderTextField(field.fieldName, field.label),
      harpType: (field) => () => renderTextField(field.fieldName, field.label),
      icCertificationNumber: (field) => () => renderTextField(field.fieldName, field.label),
      lampshadeType: (field) => () => renderTextField(field.fieldName, field.label),
      maxRotation: (field) => () => renderTextField(field.fieldName, field.label),
      maxSlopeCeiling: (field) => () => renderNumericField(field.fieldName, field.label),
      mountingProcedure: (field) => () => renderTextField(field.fieldName, field.label),
      notesWeb: (field) => () => renderTextField(field.fieldName, field.label),
      packaging: (field) => () => renderTextField(field.fieldName, field.label),
      patentNumber: (field) => () => renderTextField(field.fieldName, field.label),
      pdStockcode: (field) => () => renderTextField(field.fieldName, field.label),
      profileRomanceCopy: (field) => () => renderTextField(field.fieldName, field.label),
      prop65: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.prop65)),
      recBulb1Hyperlink: (field) => () => renderTextField(field.fieldName, field.label),
      recBulb1ManufactureID: (field) => () => renderTextField(field.fieldName, field.label),
      recBulb1Name: (field) => () => renderTextField(field.fieldName, field.label),
      recBulb2Hyperlink: (field) => () => renderTextField(field.fieldName, field.label),
      recBulb2ManufactureID: (field) => () => renderTextField(field.fieldName, field.label),
      recBulb2Name: (field) => () => renderTextField(field.fieldName, field.label),
      remoteType: (field) => () => renderTextField(field.fieldName, field.label),
      riser: (field) => () => renderTextField(field.fieldName, field.label),
      rod1Length: (field) => () => renderNumericField(field.fieldName, field.label),
      rod2Length: (field) => () => renderNumericField(field.fieldName, field.label),
      rod3Length: (field) => () => renderNumericField(field.fieldName, field.label),
      seriesDescription: (field) => () => renderTextField(field.fieldName, field.label),
      shadeExteriorMaterial: (field) => () => renderTextField(field.fieldName, field.label),
      shadeFitterType: (field) => () => renderTextField(field.fieldName, field.label),
      shadeInteriorMaterial: (field) => () => renderTextField(field.fieldName, field.label),
      shadeShape: (field) => () => renderTextField(field.fieldName, field.label),
      shadeSlant: (field) => () => renderNumericField(field.fieldName, field.label),
      standardCare: (field) => () => renderTextField(field.fieldName, field.label),
      switchDetails: (field) => () => renderTextField(field.fieldName, field.label),
      switchLocation: (field) => () => renderTextField(field.fieldName, field.label),
      tagFinishDescription: (field) => () => renderTextField(field.fieldName, field.label),
      transformerType: (field) => () => renderTextField(field.fieldName, field.label),
      treatmentTypeInterior: (field) => () => renderTextField(field.fieldName, field.label),
      vendor: (field) => () => renderAutocomplete(field.fieldName, field.label, dropDownOptions.productSuppliers),
      drawingNum: (field) => () => renderTextField(field.fieldName, field.label),
      sampleNotes: (field) => () => renderTextField(field.fieldName, field.label),
      notes: (field) => () => renderTextAreaField(field.fieldName, field.label, notesFieldRef),
      bulbInBox2: (field) => () => renderTextField(field.fieldName, field.label),
      transformerMount: (field) => () => renderTextField(field.fieldName, field.label),
      reverseSwitch: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      factoryPrimaryFinish: (field) => () => renderTextField(field.fieldName, field.label),
      factorySecondaryFinish: (field) => () => renderTextField(field.fieldName, field.label),
      factoryThirdFinish: (field) => () => renderTextField(field.fieldName, field.label),
      mfgSocketDetail: (field) => () => renderTextField(field.fieldName, field.label),
      driverPartNumber: (field) => () => renderTextField(field.fieldName, field.label),
      ledPartNumber: (field) => () => renderTextField(field.fieldName, field.label),
      // New Numeric fields
      averageBulbLife: (field) => () => renderNumericField(field.fieldName, field.label),
      backplateDepth: (field) => () => renderNumericField(field.fieldName, field.label),
      backplateHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      backplateLength: (field) => () => renderNumericField(field.fieldName, field.label),
      backplateWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      baseDepth: (field) => () => renderNumericField(field.fieldName, field.label),
      baseHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      baseLength: (field) => () => renderNumericField(field.fieldName, field.label),
      baseWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      bladePitch: (field) => () => renderNumericField(field.fieldName, field.label),
      bladeToCeilingMaxHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      bladeToCeilingMinHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      bulbBeamSpread: (field) => () => renderNumericField(field.fieldName, field.label, true),
      bulbDimmingRangeMax: (field) => () => renderNumericField(field.fieldName, field.label, true),
      bulbDimmingRangeMin: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cableLength: (field) => () => renderNumericField(field.fieldName, field.label, true),
      candleTubeDiameter: (field) => () => renderNumericField(field.fieldName, field.label),
      candleTubeShape: (field) => () => renderNumericField(field.fieldName, field.label),
      canopyDepth: (field) => () => renderNumericField(field.fieldName, field.label),
      canopyLength: (field) => () => renderNumericField(field.fieldName, field.label),
      canopyShade: (field) => () => renderNumericField(field.fieldName, field.label),
      capacitorValue: (field) => () => renderNumericField(field.fieldName, field.label, true),
      carton1DimensionalWeight: (field) => () => renderNumericField(field.fieldName, field.label),
      carton1Height: (field) => () => renderNumericField(field.fieldName, field.label),
      carton1Length: (field) => () => renderNumericField(field.fieldName, field.label),
      carton1Weight: (field) => () => renderNumericField(field.fieldName, field.label),
      carton1Width: (field) => () => renderNumericField(field.fieldName, field.label),
      carton2DimensionalWeight: (field) => () => renderNumericField(field.fieldName, field.label),
      carton2Height: (field) => () => renderNumericField(field.fieldName, field.label),
      carton2Length: (field) => () => renderNumericField(field.fieldName, field.label),
      carton2Weight: (field) => () => renderNumericField(field.fieldName, field.label),
      carton2Width: (field) => () => renderNumericField(field.fieldName, field.label),
      carton3Height: (field) => () => renderNumericField(field.fieldName, field.label),
      carton3Length: (field) => () => renderNumericField(field.fieldName, field.label),
      carton3Weight: (field) => () => renderNumericField(field.fieldName, field.label),
      carton3Width: (field) => () => renderNumericField(field.fieldName, field.label),
      cartonCount: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cfmAverage: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cfmHigh: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cfmLow: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cfmWattageHigh: (field) => () => renderNumericField(field.fieldName, field.label),
      cfmWattageLow: (field) => () => renderNumericField(field.fieldName, field.label),
      chainLink1Height: (field) => () => renderNumericField(field.fieldName, field.label, true),
      chainLink1Thickness: (field) => () => renderNumericField(field.fieldName, field.label),
      chainLink1Width: (field) => () => renderNumericField(field.fieldName, field.label),
      chainLink2Height: (field) => () => renderNumericField(field.fieldName, field.label, true),
      chainLink2Thickness: (field) => () => renderNumericField(field.fieldName, field.label),
      chainLink2Width: (field) => () => renderNumericField(field.fieldName, field.label, true),
      cordCoverBreakLength: (field) => () => renderNumericField(field.fieldName, field.label),
      cordCoverBreakWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      cordCoverQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      couplingLength: (field) => () => renderNumericField(field.fieldName, field.label),
      cutoutSize: (field) => () => renderNumericField(field.fieldName, field.label),
      deliveredLumens: (field) => () => renderNumericField(field.fieldName, field.label),
      diameter: (field) => () => renderNumericField(field.fieldName, field.label),
      dnPrice: (field) => () => renderNumericField(field.fieldName, field.label),
      efficacy: (field) => () => renderNumericField(field.fieldName, field.label),
      fanDiameter: (field) => () => renderNumericField(field.fieldName, field.label, true),
      finialHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      finialShape: (field) => () => renderNumericField(field.fieldName, field.label),
      finialWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      heightFromCenterOfJbox: (field) => () => renderNumericField(field.fieldName, field.label),
      heightWithoutTail: (field) => () => renderNumericField(field.fieldName, field.label),
      hoursLifeOnHighPower: (field) => () => renderNumericField(field.fieldName, field.label, true),
      hoursLifeOnLowPower: (field) => () => renderNumericField(field.fieldName, field.label, true),
      hoursLifeOnMedPower: (field) => () => renderNumericField(field.fieldName, field.label, true),
      imap: (field) => () => renderNumericField(field.fieldName, field.label),
      installableHeight1: (field) => () => renderNumericField(field.fieldName, field.label),
      installableHeight2: (field) => () => renderNumericField(field.fieldName, field.label),
      installableHeight3: (field) => () => renderNumericField(field.fieldName, field.label),
      installableHeight4: (field) => () => renderNumericField(field.fieldName, field.label),
      installableHeight5: (field) => () => renderNumericField(field.fieldName, field.label),
      ipCube: (field) => () => renderNumericField(field.fieldName, field.label),
      ipHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      ipLength: (field) => () => renderNumericField(field.fieldName, field.label),
      ipWeight: (field) => () => renderNumericField(field.fieldName, field.label),
      ipWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      lampSKUNetWeight: (field) => () => renderNumericField(field.fieldName, field.label, true),
      ledBoardLumen: (field) => () => renderNumericField(field.fieldName, field.label),
      ledBoardWattage: (field) => () => renderNumericField(field.fieldName, field.label),
      length: (field) => () => renderNumericField(field.fieldName, field.label),
      lightQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      maxDegree: (field) => () => renderNumericField(field.fieldName, field.label),
      maxWattage: (field) => () => renderNumericField(field.fieldName, field.label),
      maximumHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      minimumCustomHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      minimumHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      motorSize: (field) => () => renderTextField(field.fieldName, field.label),
      mountingHoleQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      mpCube: (field) => () => renderNumericField(field.fieldName, field.label),
      mpHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      mpLength: (field) => () => renderNumericField(field.fieldName, field.label),
      mpWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      mpWeight: (field) => () => renderNumericField(field.fieldName, field.label),
      numberOfBlades: (field) => () => renderNumericField(field.fieldName, field.label, true),
      numberOfSockets: (field) => () => renderNumericField(field.fieldName, field.label, true),
      packQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      qtyFabricGlassShades: (field) => () => renderNumericField(field.fieldName, field.label, true),
      rod1Qty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      rod2Qty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      rod3Qty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      rodTotalQty: (field) => () => renderNumericField(field.fieldName, field.label),
      shadeBottomDepth: (field) => () => renderNumericField(field.fieldName, field.label),
      shadeBottomWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      shadeHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      shadeQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      shadeTopDepth: (field) => () => renderNumericField(field.fieldName, field.label),
      shadeTopWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      slNetWeight: (field) => () => renderNumericField(field.fieldName, field.label),
      standardEnergyUseWave: (field) => () => renderNumericField(field.fieldName, field.label),
      standardEstimatedYearlyEnergyCost: (field) => () => renderNumericField(field.fieldName, field.label, true),
      standardWeightedAverageAirflow: (field) => () => renderNumericField(field.fieldName, field.label),
      itemVendorCost: (field) => () => renderNumericField(field.fieldName, field.label),
      wattsHigh: (field) => () => renderNumericField(field.fieldName, field.label, true),
      wattsLow: (field) => () => renderNumericField(field.fieldName, field.label),
      wattsMedium: (field) => () => renderNumericField(field.fieldName, field.label),
      widthMax: (field) => () => renderNumericField(field.fieldName, field.label),
      widthMin: (field) => () => renderNumericField(field.fieldName, field.label),
      wireLength: (field) => () => renderNumericField(field.fieldName, field.label),
      vendorMOQ: (field) => () => renderNumericField(field.fieldName, field.label, true),
      vendorLeadTime: (field) => () => renderNumericField(field.fieldName, field.label, true),
      sampleQty: (field) => () => renderNumericField(field.fieldName, field.label, true),
      targetWholesalePrice: (field) => () => renderNumericField(field.fieldName, field.label),
      targetIMAP: (field) => () => renderNumericField(field.fieldName, field.label),
      targetFOB: (field) => () => renderNumericField(field.fieldName, field.label),
      canopyHeight: (field) => () => renderNumericField(field.fieldName, field.label),
      canopyWidth: (field) => () => renderNumericField(field.fieldName, field.label),
      // New boolean fields
      fieldModify: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      hangStraight: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      canBeInverted: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.canBeInverted)),
      iS_220V: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      iS_220VNotAvailable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      ada: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      adjustable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      adjustableArm: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      articulatingShadeHead: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      assembledInTheUSA: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      assembleRequired: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      bulbIncluded: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.bulbIncluded)),
      cannotShipToCalifornia: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      cannotShipToCanada: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      cccCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      convertible: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      convertibleKitRequired: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      darkSky: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      diffuser: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      dwpIncluded: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      emcCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      energyStar: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      euCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      extendable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      fcCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      fwcCompliant: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      globalAssortmentAvailable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      hasCordCover: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      hasFanMount: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      icCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      indicatorLight: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      ipRating: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      lightKitAdaptable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      madeInTheUSA: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      madeToOrder: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      motionSensorIncluded: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      mountWallCeiling: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      mountingPlate: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      photocellIncluded: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      pivotable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      preLacedChain: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      remoteIncluded: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      replaceableLamp: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod1Cuttable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod1Removeable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod2Cuttable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod2Removeable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod3Cuttable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      rod3Removeable: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      shipByTruck: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      smartEnabled: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      title24: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      voltageConvertible: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      warmColorDimming: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      title20: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      testing: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      commission: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      inventoryItem: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      sellingItem: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      purchasingItem: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      etlCertification: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      royalty: (field) => () => renderBooleanRadioButtons(field.fieldName, field.label),
      // New Date-time fields
      sellingLineInStockDate: (field) => () => renderDatePicker(field.fieldName, field.label),
      slIntroDate: (field) => () => renderDatePicker(field.fieldName, field.label, { showTBD: true }),
      agreedSampleReadyDate: (field) => () => renderDatePicker(field.fieldName, field.label),
      numberOfDaysRequestedForSample: (field) => () => renderNumericField(field.fieldName, field.label),
      reqDate: (field) => () => renderDatePicker(field.fieldName, field.label),
      // BOM Category
      bomType: (field) => () => renderDropDown(field.fieldName, field.label, dropDownOptions.bomTypes),
      bomSearch: () => () => renderBOMAutocompleteSearch(),
      dataGridView: () => () => renderBOMGridView(),
      
      itemStatus: (field) => () => renderAutocomplete(field.fieldName, field.label, Object.entries(ITEM_STATUS_ENUM)
      .filter(([key, value]) => isNaN(Number(key)))
      .map(([key, value]) => {
          return { 
            "id": key, 
            "name":  value.replace(/([a-z])([A-Z])/g, "$1 $2")
          }
        })
      ),
      // New JDE fields
      conversionFactor: (field) => () => renderNumericField(field.fieldName, field.label),
      leadtimeLevel: (field) => () => renderNumericField(field.fieldName, field.label, true),
      shortDesc2: (field) => () => renderTextField(field.fieldName, field.label),
      harmonizedShipCode: (field) => () => renderTextField(field.fieldName, field.label),
      searchText: (field) => () => renderTextField(field.fieldName, field.label),
      itemClass: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemClass)),
      relativeTrend: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.relativeTrend)),
      class: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.class)),
      seriesName: (field) => () => (
        <AddOrSelectAutocomplete
          fieldName={field.fieldName}
          label={field.label}
          options={seriesNameOptions}
          formik={formik}
          setSelectedDropDownOptions={setSelectedDropDownOptions}
          selectedDropDownOptions={selectedDropDownOptions}
          style={{ backgroundColor: getFieldBackgroundColor(field.fieldName) }}
          disabled={isFieldDisabled(field.fieldName) || isCopyMode}
          stickyFields={stickyFields}
          onNewValueBlur={openAddSeriesName}
          onInputChange={rememberSeriesNameInput}
          loading={dropdownOptionsLoading}
          suspendCommit={addSeriesNameModalProps.isOpen}
          lockedSeriesRef={lockedSeriesRef}
        />
      ),
      brand: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.brand)),
      buyerNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.buyerNumber)),
      color: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.color)),
      division: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.division)),
      engineeringGroup: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.engineeringGroup)),
      inventoryStrategy: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.inventoryStrategy)),
      itemFlashMessage: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemFlashMessage)),
      itemPoolCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemPoolCode)),
      lampingCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.lampingCode)),
      ledRoyalty: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.ledRoyalty)),
      plannerNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.plannerNumber)),
      prepackedBanded: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.prepackedBanded)),
      purchasingABC: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.purchasingABC)),
      quickShipItem: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.quickShipItem)),
      relatedUnitofMeasure: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.relatedUnitofMeasure)),
      shippingMethod: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shippingMethod)),
      unitofMeasure: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.unitofMeasure)),
      yearCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.yearCode)),
      numberOfTiers: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.numberOfTiers)),
      family: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.family)),
      shippingConditionsCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.shippingConditionsCode)),
      applyCommissions: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.applyCommissions)),
      longItem: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.longItem)),
      itemBranchPreference: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemBranchPreference)),
      warehouseProcessGroup: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.warehouseProcessGroup)),
      itemPublicationStatus: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.itemPublicationStatus)),
      importDetails: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.importDetails)),
      layerSourceCode: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.layerSourceCode)),
      collectionPricing: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.collectionPricing)),
      contentPercent: (field) => () => renderNumericField(field.fieldName, field.label),
      shelfDays: (field) => () => renderNumericField(field.fieldName, field.label, true),
      orderMulti: (field) => () => renderNumericField(field.fieldName, field.label),
      manufacturerTransmitterItemNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.manufacturerTransmitterItemNumber)),
      manufacturerReceiverItemNumber: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.manufacturerReceiverItemNumber)),
      downrodType: (field) => () => renderAutocomplete(field.fieldName, field.label, getAttributeValues(dataFieldNames.downrodType)),
      quotesDataGridView: () => () => <AcceptedQuote
          productId={Number(sourceProductId)}
          selectedQuote={selectedQuote}
          setSelectedVendorForQuote={setSelectedVendorForQuote}
          isRefreshCalled={isRefreshCalled}
          setIsRefreshCalled={setIsRefreshCalled}
          setQuotesForEditProductPage={setQuotesForEditProductPage}
          quotesForEditProductPage={quotesForEditProductPage}
          handleQuoteSelection={handleQuoteSelection}
          editItem={editItem}
        />,
      checklistManageView: () => () => <StageCheckList
        editItemId={editItemId || sourceProductId}
        checkListStatus={checkListStatus}
        setCheckListStatus={setCheckListStatus}
        isCheckListChanged={isCheckListChanged}
        setIsCheckListChanged={setIsCheckListChanged}
        baseCode={formik?.values?.baseCode}
        isCopyMode={isCopyMode}
      />,
  };

  const formRendererNames = Object.keys(formFieldsRenderer)
 
  const handleAddbutton= () => {
    let lastSquence = bomList.length > 0 ? bomList[bomList.length-1].sequenceNum: -1;
    
    let parseIntQty = parseInt(qty);
    // Check if both selectedItemId and qty are not null or empty
    if (selectedBOMItem && qty) {
      //validation
      if ( parseIntQty >= 999) {
        setBomQtyError(true);
        setBomErrorMessage('Quantity Cannot exceed 999');
        return;
      } else if(parseIntQty <= 0) {
        setBomQtyError(true);
        setBomErrorMessage('Quantity Cannot be 0');
        return;
      }
      else {
        setBomQtyError(false);
      }
      // Create a new temporary BOM item
      const newBOMItemItem: BomGridView = {
        componentItemId: selectedBOMItem.id,
        stockcode: selectedBOMItem.stockcode,
        longDesc: selectedBOMItem.longDesc,  
        sequenceNum: lastSquence +1,
        skuType: selectedBOMItem.skuType, 
        quantity: parseIntQty,
        fobCost: selectedBOMItem?.fobCost,
        ipCube: selectedBOMItem?.ipCube,
        dnPrice: selectedBOMItem?.dnPrice,
        umapPrice: selectedBOMItem?.umapPrice,
        grossGMPercent: selectedBOMItem?.grossGMPercent,
        vendorDisplayText: selectedBOMItem?.vendorDisplayText,
        quoteDate: selectedBOMItem?.quoteDate,
        quoteApprovalType: selectedBOMItem?.quoteApprovalType
      };
      
      // Add the new temporary BOM item to the temporary list
      setBomList([...bomList, newBOMItemItem]);
      
      // Clear bomSearchTerm fields after adding
      setSelectedBOMItem(null);
      setSearchTerm('');
      setQty('');
    } else {
      console.error("Please select a stock code and provide quantity.");
    }
  };
  
  const handleSelectedItem = (item: BomGridView | null) => {
    setSelectedBOMItem(item);
  };

  const handleAddBOMComponent = () => {
    setShowAddBOMComponentModal(true);
  };

  const handleBOMComponentCloseModal = () => {
    setShowAddBOMComponentModal(false);
  };

  // const handleSyncSAPComponent = () => {
  //   api.post<ApiResponse<boolean>>("/component/sap-syncup", null)
  //     .then((response) => {
  //       if(response?.isSuccess) {
  //         toast.success(response?.message);
  //       }
  //       else {
  //         toast.error(response?.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Exception from Sync SAP Component", error);
  //     });
  // };
  
  const [validateOnBlur, setValidateOnBlur] = useState(false);
  const renderBOMAutocompleteSearch=() => (
    (sessionService.hasPermission(Permissions.ManageBOM) && formik.values.bomType) &&
    <>
      <Divider sx = {{marginTop: "10px"}}/>
      <FormControl style = {{marginTop: "12px"}}>
        <Box sx = {{display: "flex", flexDirection: "column"}}>
          <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Typography>Add BOM</Typography>
            <Box sx={{ display: "flex" }}>
              <Button variant="contained" onClick={handleAddBOMComponent}>
                Add New Component
              </Button>
              {/* <Button variant="contained" style={{ marginLeft: "5px" }} onClick={handleSyncSAPComponent}>
                Sync SAP Components
              </Button> */}
            </Box>
          </Box>
          <Box sx = {{display: "flex", flexDirection: "row", alignItems: "center", marginTop: "15px", gap: "10px" }}>
            <AutoCompleteStockCode
              bomList = {bomList}
              selectedItem = {handleSelectedItem}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            /> 
            <TextField
              label = {bomQtyError? bomErrorMessage : "Qty"}
              className="hide-input-arrow"
              inputProps={{ type: "number"}}
              onKeyDown={(e) => {
                (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()
                // Get the key value directly from event.key
                const charStr = e.key;
                // Allow only digits (0-9) and control keys like Backspace
                if (!/^\d$/.test(charStr) && e.key !== 'Backspace') {
                  e.preventDefault();
                  }
                }
              }
              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
              value={qty || ''}
              onChange = {(event) => {
                const value = event.target.value;
                if (validateOnBlur) {
                    const parsedQty = parseInt(value);
                    if (isNaN(parsedQty) || parsedQty <= 0 || parsedQty >= 999) {
                        setBomQtyError(true);
                        setBomErrorMessage(parsedQty >= 999 ? 'Quantity Cannot exceed 999' : 'Quantity Cannot be 0');
                    } else {
                        setBomQtyError(false);
                        setBomErrorMessage('');
                    }
                }
                setQty(value);
              }}
              onBlur={() => setValidateOnBlur(true)}
              error = {bomQtyError}
              />
            <Button variant="contained" onClick = {handleAddbutton}>
              Add
            </Button>
          </Box>
        </Box>
      </FormControl>
    </>
  );


  const handleDeleteBom = (params: any) => {
    const bomListAfterRemoval = bomList.filter(b => b.stockcode != params.stockcode);
    //reassign the sequence after delete
    bomListAfterRemoval.forEach((bom, index) => {
      bomListAfterRemoval[index].sequenceNum = index;
    });
    setBomList(bomListAfterRemoval);
  };

  const BOMDataGridCollumns = useMemo<MRT_ColumnDef<BomGridView>[]>(() => [
    { accessorKey: "stockcode", header: "Stock Code", size: 100 },
    { accessorKey: "longDesc", header: "Description", size: 120 },
    { accessorKey: "sequenceNum", header: "Sequence Number", size: 100 },
    { accessorKey: "skuType", header: "SKU Type", size: 120 },
    { accessorKey: "quantity", header: "Qty", size: 100 },
    { accessorKey: "fobCost", header: "FOB Cost", size: 100, Cell: ({ row }) => {
      return row.original.fobCost ? formatAmount(row.original.fobCost, "USD") : ''
    } },
    { accessorKey: "ipCube", header: "IP Cube", size: 100 },
    { accessorKey: "dnPrice", header: "DN", size: 100, Cell: ({ row }) => {
      return row.original.dnPrice ? formatAmount(row.original.dnPrice, "USD") : ''
    } },
    { accessorKey: "umapPrice", header: "UMAP", size: 100, Cell: ({ row }) => {
      return row.original.umapPrice ? formatAmount(row.original.umapPrice, "USD") : ''
    } },
    { accessorKey: "grossGMPercent", header: "Gross GM Percent", size: 100, Cell: ({ row }) => {
      return row.original.grossGMPercent ? `${row.original.grossGMPercent}%` : ''
    } },
    { accessorKey: "vendorDisplayText", header: "Vendor", size: 100 },
    {
      accessorKey: "quoteDate", header: "Quote Date", size: 100, Cell: ({ row }) => {
        const quoteDate = row.original.quoteDate;
        return quoteDate ? moment(quoteDate).format(DATE_FORMAT) : ''
      }
    },
    {
      accessorKey: "quoteApprovalType", header: "Quote Approval Type", size: 100, Cell: ({ row }) => {
        const quoteApprovalType = row.original.quoteApprovalType;
        return QUOTE_APPROVAL_TYPE_DROPDOWN_OPTIONS.find((qa) => qa.id === quoteApprovalType)?.name || ''
      }
    },
  ], []);

  const table = useMaterialReactTable({
    columns: BOMDataGridCollumns,
    data: bomList,
    enablePagination: false,
    enableRowActions: !checkBOMPermission(),
    positionActionsColumn: !checkBOMPermission() ? "last" : null,
    enableRowOrdering: !checkBOMPermission(),
    enableSorting: false,
    enableFilters: false,
    enableCellActions: !checkBOMPermission(),
    enableColumnActions: false,
    renderRowActions: (({row}) => {
      if (checkBOMPermission()) return null;
      return (
        <IconButton onClick={() => handleDeleteBom(row.original)}>
          <Delete />
        </IconButton>
      )
    }),
    muiRowDragHandleProps: !checkBOMPermission() ?
     ({table}) => ({
      onDragEnd: async () => {
        const {draggingRow, hoveredRow} = table.getState();
        if(draggingRow && hoveredRow) {
          bomList.splice(
            (hoveredRow as MRT_Row<BomGridView>).index,0,
            bomList.splice(draggingRow.index, 1)[0]
          );
          setBomList([...bomList]);
          await updateSequenceNumber(bomList);
        }
      }
    }) : null
  });

  const updateSequenceNumber = async (reOrderedList: any) => {
    let sort = 0;
    reOrderedList.forEach((bom) => {
      bom.sequenceNum = sort;
      sort++;
    });
  }

  const renderBOMGridView = () => {
    return (
      <Box style={{ marginTop: '2%', width: '100%' }}>
        <MRT_TableContainer table={table} sx={{ scrollbarWidth: "thin" }} />
      </Box>
    )
  }

  /**
   * This function is used to filter attachment list and store attachment id in state to delete attachment(s)
   * @param index - Array index of attachment list
   */
  const handleRemoveAttachment = (index: number) => {
    const updatedAttachments = attachments.filter(
      (a, i) => i !== index
    );
    let removeId;

    attachments.filter(
      (a, i) => i === index && a.disabled === true
    ).map((item) => {
      return removeId = item.attachId
    });
    setAttachments(updatedAttachments);

    if (removeId) {
      setDeleteAttachmentIds([...deleteAttachmentIds, removeId]);
    }
  };

  /**
   * This function is used to handle remove selected tag
   * @param tagId - Tag Id
   */
  const handleRemoveTag = (tagId: number) => {
    // Remove tag from selected tag state
    const tagsAfterRemoval = selectedTagOptions.filter((st) => st.id !== tagId);
    // Add tag in tag menu options which is currently removed from selected tag
    const removedTagInfo = selectedTagOptions.find(t => t.id === tagId);
    const sortedTagMenuOptions = [...tagMenuOptions, removedTagInfo].sort((a, b) => a.id > b.id ? 1 : -1);
    setSelectedTagOptions(tagsAfterRemoval);
    setTagMenuOptions(sortedTagMenuOptions);    
  };

  /**
   * This function is used to handle tag option selection
   * @param tagToAdd - Selected Tag Option
   */
  const handleTagOptionSelect = (tagToAdd: Tag) => {
    // Add tag in selected tag option to display selected tags button
    setSelectedTagOptions([...selectedTagOptions, tagToAdd]);
    // Remove the selected tag from tag menus so that it cannot be selected again
    let updateTagOptions = tagMenuOptions.filter(t => t.id !== tagToAdd.id);
    setTagMenuOptions(updateTagOptions);
  };

  /**
   * This function is used to handle accordian group expand / collapse
   * @param group - Accordian group name
   */
  const handleAccordianExpand = (group: string) => {
    const isSectionOpen = accordianExpanded.includes(group);

    // Check if section is expanded (group name present in array) and also check required field contains value
    if (isSectionOpen && formik.values[FIELD_NAMES.brandCollection] && formik.values[FIELD_NAMES.shortDesc]) {
      // Remove the group from the expanded array
      const updatedOpenSections = accordianExpanded.filter(sec => sec !== group);
      setAccordianExpanded(updatedOpenSections);
    } else {
      // Add the group to the expanded array
      setAccordianExpanded([...accordianExpanded, group]);

      // If the section is being expanded for the first time, mark it as rendered
      if (!sectionOpenHistory.includes(group)) {
        setSectionOpenHistory([...sectionOpenHistory, group]);
      }
    }
  };

  useEffect(() => {
    const handleConfirmationSet = async () => {
      if (isConfirmationSet) {
        if (isCopyMode) {
          await submitCopyProduct();
        }
        else {
          await submitFormDataToItemApi();
        }
      }
    };
    handleConfirmationSet();
  }, [isConfirmationSet]);

  const handleBaseCodeModificationModalClose = () => {
    setShowBaseCodeModificationConfirmModal(false);
    setDisableSubmit(false);
  };

  const handleBaseCodeModificationConfirm = (baseCodeModificationConfirm: string) => {
    setIsBasecodeModifyForAll(baseCodeModificationConfirm === "Yes");
    
    // Check if there are any base code level checklists
    const basecodeLevelChecklists = checkListStatus?.find(chl => chl.isBaseCodeLevel === true);
    if(basecodeLevelChecklists) {
      setIsLoadingExpand(true);
      // If there are base code level checklists, show the confirmation modal for checklist modification
      setTimeout(() => {
        setShowBaseCodeLevelCheckListModificationConfirmModal(true);
        setIsLoadingExpand(false);
      }, 500);
    }
    else{
      setIsConfirmationSet(true);
    }

    handleBaseCodeModificationModalClose();
  };

  const handleBaseCodeLevelCheckListModificationConfirmModalClose = () => {
    setShowBaseCodeLevelCheckListModificationConfirmModal(false);
    setDisableSubmit(false);
  };

  const handleBaseCodeLevelCheckListModificationConfirm = (baseCodeLevelCheckListModificationConfirm: string) => {
    setIsBasecodeChecklistApplyForAll(baseCodeLevelCheckListModificationConfirm === "Yes");
    setIsConfirmationSet(true);
    handleBaseCodeLevelCheckListModificationConfirmModalClose();
  };

  const addCommentSubmitToApi = async (newComment: NewComment) => {
    const { comment, isBaseCodeChecked } = newComment;

    const addNewCommentResponse = await api.post<ApiResponse<number>>(
      `/ProductComment/add`,
      {
        productId: editItemId,
        comment: comment,
        commentType: "General",
        baseCode: isBaseCodeChecked ? editItem.baseCode : null,
        pdBaseCode: isBaseCodeChecked ?  editItem.pdCode : null,
        images: newComment?.images || null
      });
    if (addNewCommentResponse?.isSuccess) {
      fetchProductCommentList();
    }
  };

  const updateCommentSubmitToApi = async (updatedComment: NewComment) => {
    const { id, comment, isBaseCodeChecked } = updatedComment;

    const updateCommentResponse = await api.put<ApiResponse<boolean>>(
      `/ProductComment/edit/${id}`,
      {
        id: id,
        productId: editItemId,
        comment: comment,
        baseCode: isBaseCodeChecked ? editItem.baseCode : null,
        pdBaseCode: isBaseCodeChecked ?  editItem.pdCode : null,
        images: updatedComment?.images || null
      });
    if (updateCommentResponse?.isSuccess) {
      fetchProductCommentList();
    }
  };

  const handleCommentFormSubmit = async (newComment: NewComment) => {
    // This condition is to check if user has added a new comment to submit
    if(newComment.id === 0) {
      addCommentSubmitToApi(newComment);
    }
    // else user has updated existing comment from the list
    else {
      updateCommentSubmitToApi(newComment);
    }
  };

  const handleDeleteComment = async (commmentId: number) => {
    const deleteCommentResponse = await api.delete<ApiResponse<boolean>>(
      `/ProductComment/delete/${commmentId}`);
    if (deleteCommentResponse?.isSuccess) {
      fetchProductCommentList();
    }
  };

  /**
   * This function is used to render accordian based on grouped fields. each groups accordian containg some fields
   * @param group - Accordian group name
   * @param fields - Accordian field name of groups
   */
  const renderFormSection = (
    group: string,
    fields: ProductLayoutFieldDetail[]) => {

    const fieldWithCols = {
      Dimensions: 4,
      Lamping: 6,
      ['Product Details']: 6,
    };

    const fullWidthFields = ["notes"];

    const shouldRenderFields = accordianExpanded.includes(group) || sectionOpenHistory.includes(group);

    return (
      <Accordion
        key={group}
        expanded={accordianExpanded.includes(group)}
        onChange={() => handleAccordianExpand(group)}
      >
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          aria-controls={`panel-${group}-content`}
          id={`panel-${group}-header`}
          className={`accordians-summary-edit-product ${accordianExpanded.includes(group) ? "active-accordian-expanded" : ""}`}
        >
          {accordianExpanded.includes(group) ? <RemoveIcon /> : <AddIcon />}
          <Typography style={{ fontWeight: accordianExpanded.includes(group) ? "bold" : "normal" }}>
            {group}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className="accordian-input-fields">
          <Grid container>
            {shouldRenderFields &&
              fields.sort((a, b) => a.tabOrder - b.tabOrder).map(field => {
                const renderFunction = formFieldsRenderer[formRendererNames.find((fieldName) => !stickyFields.find(item => item.fieldName === fieldName) && fieldName.toLowerCase() === field.fieldName.toLowerCase())];
                return <Grid item xs={Object.keys(fieldWithCols).includes(group) && !fullWidthFields.includes(field.fieldName) ? fieldWithCols[group] : 12} key={`normal-field-${field.fieldName}`}>
                  {renderFunction ? renderFunction(field)() : null}
                </Grid>
              })}
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  };

  const checkBaseCodeExist = Boolean(formik.values.baseCode);

  const handleDeleteModal = () => {
    setDeleteModal(true);
  };

  const floatingButton = () => {
    setShowButtons(!showButtons);
  };

  const handleDeactivateProduct = async () => {
    try{
      api
        .patch<ApiResponse<boolean>>(`/Item/active-deactive`, {
          id: editItemId,
          isActive: false
        })
        .then( async (response:any) => {
          if(response.isSuccess){
            toast.success(response.message);
            setDeleteModal(false);
            navigate("/products")
          }
        })
        .catch(() => {});
    }catch(error: any) {
      toast.error(error.message);
    }
  };

  const setProductIPCube = () => {
    return (formik.values.ipCube || null);
  };

  // This function is used to close the Quote Details Comparison Modal
   const onIPCubeUpdatesModalClose = () => {
    setQuoteCalculationFieldsUpdateModalOpen(false);
    setIsSubmitting(false);
  };

  const handleExpandCollapseAll = () => {
    setIsLoadingExpand(true);
  
    setTimeout(() => {
      if (expandAll) {
        setAccordianExpanded([]);
      } else {
        if(sectionOpenHistory?.length !== accordianCategories?.length) {
          setSectionOpenHistory(accordianCategories);
        }
        setAccordianExpanded(accordianCategories);
      }
      setExpandAll(!expandAll);
      setIsLoadingExpand(false);
    }, 50);
  };

  const flattenFormikErrors = (errs: any, pathPrefix = ""): string[] => {
    if (!errs) return [];
    if (typeof errs === "string") {

      const label = fieldLabelsPair[pathPrefix];
      return [label ? `${label}: ${errs}` : errs]
    };
    if (Array.isArray(errs)) {
      return errs.flatMap((item, idx) => flattenFormikErrors(item, pathPrefix ? `${pathPrefix}[${idx}]` : `[${idx}]`));
    }
    if (typeof errs === "object") {
      return Object.entries(errs).flatMap(([key, value]) => {
        const nextPath = pathPrefix ? `${pathPrefix}.${key}` : key;
        return flattenFormikErrors(value, nextPath);
      });
    }
    return [];
  };

  const touchedFromErrors = (errs: any): any => {
    if (!errs) return {};
    if (typeof errs === "string") return true;
    if (Array.isArray(errs)) return errs.map((e) => touchedFromErrors(e));
    if (typeof errs === "object") {
      return Object.fromEntries(Object.entries(errs).map(([k, v]) => [k, touchedFromErrors(v)]));
    }
    return true;
  };
  const toastId = useRef<any>(null);
  const lastLocationKey = useRef<string>(`${location?.pathname ?? ""}${location?.search ?? ""}${location?.hash ?? ""}`);

  useEffect(() => {
    const nextKey = `${location?.pathname ?? ""}${location?.search ?? ""}${location?.hash ?? ""}`;
    const prevKey = lastLocationKey.current;
    lastLocationKey.current = nextKey;

    // If user navigates away while a persistent toast is open, close it.
    if (prevKey !== nextKey && toastId.current != null) {
      toast.dismiss(toastId.current);
      toastId.current = null;
    }
  }, [location?.pathname, location?.search, location?.hash]);

  useEffect(() => {
    return () => {
      if (toastId.current != null) {
        toast.dismiss(toastId.current);
        toastId.current = null;
      }
    };
  }, []);

  const showFormikSubmitErrors = (errs: any) => {
    const lines = flattenFormikErrors(errs);
    if (!lines.length) return;

    // Keeps it readable without spamming huge toasts.
    const maxToShow = 6;
    const head = lines.slice(0, maxToShow);
    const more = lines.length > maxToShow ? ` (+${lines.length - maxToShow} more)` : "";
    const msg = `The following fields need to be corrected:\n${head.join("\n")}${more}`;
    toastId.current = toast.error(<div style={{ whiteSpace: "pre-line" }}>{msg}</div>, {
      autoClose: false,
      progress: 1
    });
    console.error("Formik submit blocked due to validation errors:", errs);
  };

  const handleSubmitWithErrorList = async (e: any) => {
    e?.preventDefault?.();
    
    const errs = await formik.validateForm();
    // close old toast
    toast.dismiss(toastId.current);
    if (errs && Object.keys(errs).length > 0) {
      formik.setTouched(touchedFromErrors(errs), true);
      showFormikSubmitErrors(errs);
      return;
    }

    formik.handleSubmit(e);
  };

  return (
    <>
      <AddSeriesNameModal {...addSeriesNameModalProps} />
      {<ConfirmationModal
        isOpen={deleteModal}
        onClose={handleCloseModal}
        title={"Confirm Deactivate Product"}
        message={"Are you sure you want to deactivate this product?"}
        handleConfirmYes={handleDeactivateProduct}
        handleConfirmNo={handleCloseModal}
      />}
      {quoteCalculationFieldsUpdateModalOpen && (
        <QuoteDetailsComparisonModal
          open={quoteCalculationFieldsUpdateModalOpen}
          onClose={onIPCubeUpdatesModalClose}
          oldValues={oldQuoteDetailsForIPCubeUpdates}
          newValues={newQuoteDetailsForIPCubeUpdates}
          changedFieldsForCalculation={changedFieldsForCalculation}
          handleSaveProduct={() => onSubmitHandler()}
          isSubmitting={isSubmitting}
        />)}
      {<ConfirmationModal
        isOpen={showConfirmModal}
        onClose={handleCloseModal}
        title={"Confirm BaseCode Auto Generate"}
        message={"Are you sure you want to regenerate Base Code for this product?"}
        handleConfirmYes={handleBaseCodeAuto}
        handleConfirmNo={handleCloseModal}
      />}
      <ConfirmationModal
        isOpen={showBaseCodeModificationConfirmModal}
        onClose={handleBaseCodeModificationModalClose}
        title={"Confirm BaseCode Modification"}
        titleForConfirmYesButton={"Yes, Change All"}
        titleForConfirmNoButton={"No, Change Current Product Only"}
        message={<>
          You modified BaseCode From {editItem?.baseCode} TO {formik.values[FIELD_NAMES.baseCode]}.
          <br /> Do you want to update the new BaseCode for all Products having current BaseCode value {editItem?.baseCode}?
        </>}
        handleConfirmYes={() => handleBaseCodeModificationConfirm("Yes")}
        handleConfirmNo={() => handleBaseCodeModificationConfirm("No")}
      />
      <ConfirmationModal
        isOpen={showBaseCodeLevelCheckListModificationConfirmModal}
        onClose={handleBaseCodeLevelCheckListModificationConfirmModalClose}
        title={"Confirm BaseCode Level CheckList Modification"}
        titleForConfirmYesButton={"Yes, Change All"}
        titleForConfirmNoButton={"No, Change Current Product Only"}
        message={<>
          You modified BaseCode level checklists.
          <br /> Do you want to update the Checklist status for all Products sharing the same BaseCode?
        </>}
        handleConfirmYes={() => handleBaseCodeLevelCheckListModificationConfirm("Yes")}
        handleConfirmNo={() => handleBaseCodeLevelCheckListModificationConfirm("No")}
      />
      <BOMComponentModal
        isOpen={showAddBOMComponentModal}
        onClose={handleBOMComponentCloseModal}
        isButtonDisabled={disableSubmit}
        layoutFields={productLayoutFields}
        dropDownOptions={dropDownOptions} 
        />
      <div>
      <Box
        className="edit-item-main-container"
        style={{ width: pageQueryParams ? "80%" : "100%"}}
      >
        <Card sx={{ marginBottom: 1 }} className="accordian-container">
          <CardContent>
            <Loader isLoading={isLoadingExpand} />
            <div style={{ display: "flex" }}>
              {editItem &&
                <span
                  className="title-text"
                >
                  {isCopyMode
                    ? `Copy Product – Base Code: ${copyBaseCode || '–'} | PD Stock Code: ${copyPdStockcode || '–'} | Stock Code: ${copyStockcode || '–'}`
                    : `${editItem.shortDesc ? `${editItem.shortDesc} - ` : ""}${
                        editItem.stockcode ? editItem.stockcode : `Product Id ${editItem.id}`
                      }`}
                </span>}
              <span style={{ marginLeft: "auto", cursor: "pointer" }}>
                <CloseIcon onClick={()=> navigate("/products")} />
              </span>
            </div>
            {(sessionService.hasPermission(Permissions.CreateProduct) || 
              sessionService.hasPermission(Permissions.UpdateProduct) || 
              sessionService.hasPermission(Permissions.ViewProducts) ||
              sessionService.hasPermission(Permissions.ManageTags)) &&
              Object.keys(dropDownOptions).length > 0 && (
                <Tags
                  selectedTagOptions={selectedTagOptions}
                  tagDropDownOptions={tagMenuOptions}
                  handleRemoveTag={handleRemoveTag}
                  handleTagOptionSelect={handleTagOptionSelect}
                  uniqueTagsIdList = {uniqueTagsIdList}
                />
              )}
              <form onSubmit={handleSubmitWithErrorList} >
                <div className={`floating-button-container ${pageQueryParams ? "grid-view-presents" : "no-grid-view"}`}>
                  {showFab 
                    && <Fab
                    variant="circular" 
                    size="medium"
                    onClick = {floatingButton}
                  >
                    <AddIcon className="plus-icon" />
                  </Fab>}
                  {showButtons && showFab &&
                    <>
                      <Fab
                        variant="extended"
                        size="medium"
                        sx={{ padding: "15px", margin: "10px", marginRight: "0px" }}
                        type="button"
                        onClick={() => handleExpandCollapseAll()}
                      >
                        {`${expandAll ? "Collapse" : "Expand"} All`}
                      </Fab>
                      {sessionService.hasPermission(Permissions.ActivateDeactivateProduct) && showFab && !isCopyMode &&
                        <Fab
                          variant="extended"
                          size="medium"
                          sx={{ padding: "15px", margin: "10px" }}
                          onClick={handleDeleteModal}
                          disabled={disableSubmit}
                        >
                          Deactivate
                        </Fab>}
                      {(sessionService.hasPermission(Permissions.ManageAttachments) ||
                        sessionService.hasPermission(Permissions.ManageProductAssignments) ||
                        sessionService.hasPermission(Permissions.ManageTags) ||
                        sessionService.hasPermission(Permissions.ManageBOM) ||
                        sessionService.hasPermission(Permissions.UpdateProduct) ||
                        assignmentEditableFields?.length > 0) && showFab &&
                        <Fab
                          variant="extended"
                          size="medium"
                          sx={{ padding: "10px" }}
                          type="submit"
                          disabled={disableSubmit}
                        >
                          Submit
                        </Fab>}
                    </>}
                </div>
                <div className="edit-product-button-container">
                  {(sessionService.hasPermission(Permissions.ManageAttachments) ||
                    sessionService.hasPermission(Permissions.ManageProductAssignments) ||
                    sessionService.hasPermission(Permissions.ManageTags) ||
                    sessionService.hasPermission(Permissions.ManageBOM) ||
                    sessionService.hasPermission(Permissions.UpdateProduct) ||
                    assignmentEditableFields?.length > 0)
                    && <Button
                      type="submit"
                      variant="contained"
                      style={{ float: "right" }}
                      disabled={disableSubmit}
                    >
                      Submit
                    </Button>}
                    {sessionService.hasPermission(Permissions.ActivateDeactivateProduct) && !isCopyMode
                    && <Button
                      variant="contained"
                      style={{ float: "right", marginRight: '10px'}}
                      disabled={disableSubmit}
                      onClick={handleDeleteModal}
                    >
                      Deactivate
                    </Button>}
                </div>
                {stickyFields?.length > 0 && productLayoutFields?.length > 0 && formRendererNames?.length > 0 && <Grid container spacing={2} className="frozen-fields-container">
                  {/* rendering field Product ID only in edit mode */}
                  {!isCopyMode && <Grid item xs={1.5} key="frozen-field-id">
                    {renderTextField(stickyFields[0].fieldName, stickyFields[0].label)}
                  </Grid>}
                  {stickyFields?.map((field, index) => {
                    const renderFunction = formFieldsRenderer[field.fieldName] ? formFieldsRenderer[field.fieldName] : null;
                    if(renderFunction) {
                      return <Grid item xs={field.fieldName === "longDesc" ? 9 : index < 5 ? (isCopyMode ? 3 : 2.625) : 3} key={`frozen-field-${field.fieldName}`}>
                        {renderFunction ? renderFunction(field)() : null}
                      </Grid>
                    }
                  }
                  )}
                </Grid>}
                <div className="form-div-container">
                  <div className="layout-field-category-list">
                    {productLayoutFields?.length > 0 &&
                      productLayoutFields
                        .sort((a, b) => a.tabOrder - b.tabOrder)
                        .map((lf) => renderFormSection(lf.categoryName, lf.fields))}
                  </div>
                  {!!toolingDetails?.seriesName ? <ToolingInformation toolingDetails={toolingDetails} /> : null}
                  {((editItem && !isCopyMode) && (sessionService.hasPermission(Permissions.CreateProduct) ||
                    sessionService.hasPermission(Permissions.UpdateProduct) ||
                    sessionService.hasPermission(Permissions.ViewProducts) ||
                    sessionService.hasPermission(Permissions.ManageProductAssignments)) &&
                    (formValueBaseCode?.trim() && selectedUserAssignments?.length > 0 && selectedUserAssignments[0].id 
                    && userAssignmentsApiRunning === false)) ? 
                    (<UserAssignments
                      selectedUserAssignments={selectedUserAssignments}
                      setSelectedUserAssignments={setSelectedUserAssignments}
                      viewMode="EditProduct"
                      assignmentRoleDropdownOptions={assignmentRoleDropdownOptions}
                      userDropdownOptions={userDropdownOptions}
                      classNames="product-page"
                      baseCode={formik.values[FIELD_NAMES.baseCode]?.trim()}
                    />) : null}
                  {((editItem && !isCopyMode) && (sessionService.hasPermission(Permissions.CreateProduct) ||
                    sessionService.hasPermission(Permissions.UpdateProduct) ||
                    sessionService.hasPermission(Permissions.ViewProducts) ||
                    sessionService.hasPermission(Permissions.ManageProductAssignments)) &&
                    (formValueBaseCode?.trim() && userAssignmentsApiRunning === false && 
                      ((selectedUserAssignments?.length > 0 && selectedUserAssignments[0].id === 0) 
                      || (!selectedUserAssignments) || selectedUserAssignments?.length === 0))) &&
                      <div className="no-assignment-warning">
                        <Box className="custom-box">
                          <Typography variant="h6">Product Assignments</Typography>
                          <Typography className="no-assignments-text">{NO_ASSIGNMENTS_WARNING}</Typography>
                        </Box>
                      </div>
                  }
                  {((editItem && isCopyMode) && (sessionService.hasPermission(Permissions.CreateProduct) ||
                    sessionService.hasPermission(Permissions.UpdateProduct) ||
                    sessionService.hasPermission(Permissions.ViewProducts) ||
                    sessionService.hasPermission(Permissions.ManageProductAssignments)) &&
                    (formValueBaseCode?.trim() && userAssignmentsApiRunning === false)) ? 
                    (<UserAssignments
                      selectedUserAssignments={selectedUserAssignments}
                      setSelectedUserAssignments={setSelectedUserAssignments}
                      viewMode="EditProduct"
                      assignmentRoleDropdownOptions={(Array.isArray(assignmentRoleDropdownOptions) ? assignmentRoleDropdownOptions.sort(sortByKey()) : []) as KeyValues[]}
                      userDropdownOptions={(Array.isArray(userDropdownOptions) ? userDropdownOptions.sort(sortByKey()) : []) as UserDropdownOptions[]}
                      classNames="product-page"
                      baseCode={formik.values[FIELD_NAMES.baseCode]?.trim()}
                      editable={isCopyMode && +selectedUserAssignments[0]?.id === 0}
                      isCopyMode={isCopyMode}
                    />) : null}
                  </div>
                {(sessionService.hasPermission(Permissions.CreateProduct) ||
                  sessionService.hasPermission(Permissions.UpdateProduct) ||
                  sessionService.hasPermission(Permissions.ViewProducts) ||
                  sessionService.hasPermission(Permissions.ManageAttachments)) &&
                  <div style={{ marginTop: "20px" }}>
                    {attachments.length > 0 || sessionService.hasPermission(Permissions.ManageAttachments) ?
                      <AttachmentsUploader
                        title="Upload"
                        onRemove={handleRemoveAttachment}
                        attachments={attachments}
                        setAttachments={setAttachments}
                        attachmentTypeDropdownOptions={dropDownOptions.attachmentTypes}
                        setShowFab = {setShowFab}
                        setDisableSubmit={setDisableSubmit}
                        ref={uploaderRef}
                        isCopyMode={isCopyMode}
                      /> : null}
                  </div>}
                <ProductComments
                  commentList={commentList}
                  onSubmit={handleCommentFormSubmit}
                  onDelete={handleDeleteComment}
                  editItem={editItem}
                  isCopyMode={isCopyMode}
                />
              </form>
          </CardContent>
        </Card>
      </Box>
    </div>
    {pageQueryParams &&
      <EditProductGridView editItemId={editItemId} />}
    </>
  );
};
export default EditProduct;
